/** Homepage, footer extras, and for-hospitals body copy. Overlay after nav packs. */

export const HOME_BODIES = {
  hi: {
    openTheApp: 'मुफ़्त शुरू करें',
    langStatWrite: 'भाषाएँ जिनमें लिख सकते हैं',
    langStatSpeak: 'भाषाएँ जिनमें बोल सकते हैं',
    speakInLangs: '{n} भाषाओं में बोलें।',
    howSub: 'कोई फ़ॉर्म नहीं, कोई मेनू नहीं। लिखना पहले से {n} भाषाओं में चलता है।',
    howAskP: 'जैसा बोलते हैं वैसा लिखें, {n} भाषाओं में। chemotherapy और platelets अंग्रेज़ी में रखें। अमेरिकी देखभाल के लिए अंग्रेज़ी डिफ़ॉल्ट है।',
    howAnswerH: 'छोटा, इंसान जैसा जवाब',
    howAnswerP: 'दो-तीन वाक्य, जैसे सामने बैठा कोई समझाए। टेक्स्ट की दीवार नहीं, चेतावनियों की लिस्ट नहीं, और कभी निदान नहीं।',
    howRememberH: 'वह याद रखती है',
    howRememberP: 'कैंसर का प्रकार, रेजिमेन, कौन सा साइकल, आपका शहर, आप मरीज हैं या बेटा। अगले हफ्ते आएँ और बात जारी रहे। माँ का निदान किसी मशीन को दो बार नहीं समझाना पड़ता।',
    scopeUltra: 'अति-दुर्लभ: DIPG, ATRT, SCCOHT, BPDCN',
    scopeVery: 'बहुत दुर्लभ: कॉर्डोमा, एंजियोसारकोमा, यूवियल मेलेनोमा',
    scopeRare: 'दुर्लभ: GIST, मेसोथेलियोमा, Ewing sarcoma',
    scopeCommon: 'सामान्य और कम सामान्य: स्तन, फेफड़ा, कोलोरेक्टल, मायलोमा',
    cardTreatH: 'इलाज और ट्रांसप्लांट',
    cardTreatP: 'सर्जरी, कीमोथेरेपी, रेडिएशन, टारगेटेड और इम्यूनोथेरेपी। बोन मैरो और स्टेम सेल ट्रांसप्लांट पूरा: डोनर मैचिंग, कंडीशनिंग, इंग्राफ्टमेंट, आइसोलेशन के हफ्ते, GVHD, और उसके बाद की ज़िंदगी। CAR-T, क्लिनिकल ट्रायल, जीनोमिक टेस्ट।',
    cardWarnH: 'जिसकी कोई चेतावनी नहीं देता',
    cardWarnP: 'जब कुछ स्वाद न दे तो क्या खाएँ। साइकल के बीच यात्रा सुरक्षित है या नहीं। काम पर वापसी। नज़दीकी और फर्टिलिटी। बाल, त्वचा, स्टोमा और लिम्फोएडीमा। रात 3 बजे वापसी का डर। देखभाल करने वाले जो सोए नहीं।',
    cardMoneyH: 'पैसा और लॉजिस्टिक्स',
    cardMoneyP: 'पहले अमेरिकी इंश्योरेंस की भाषा: Medicare, Medicaid, कमर्शियल प्लान। फिर अस्पताल मैच, खर्च अनुमान, और जब सवाल वही हो तो भारत की योजनाएँ, Ayushman Bharat समेत।',
    cardRareH: 'दुर्लभ कैंसर, बिना कंधे उचकाए',
    cardRareP: 'DIPG, ATRT, कॉर्डोमा, GIST और बाकी जो वेटिंग रूम के पम्फलेट में लगभग नहीं दिखते। जीवविज्ञान सादे शब्दों में, विशेषज्ञ से क्या पूछें, और झूठी उम्मीद के बिना ट्रायल कैसे देखें।',
    cardCareH: 'उनके बगल वाले के लिए',
    cardCareP: 'वेटिंग रूम में पति-पत्नी, पोर्टल पर वयस्क बेटा-बेटी, रेडिएशन तक ले जाने वाला दोस्त। बच्चे को कैसे बताएँ, घर पर क्या देखें, दूसरी राय कब माँगें, और खुद कैसे खड़े रहें।',
    cardRefuseH: 'जो वह मना करती है',
    cardRefuseP: 'कैंसर से असंबंधित सब कुछ, एक पंक्ति में। कोई निदान नहीं, कोई डोज़ नहीं, कोई दवा शुरू या बंद करने को नहीं कहना। अन्य बीमारियाँ तभी जब वे कैंसर के इलाज से छूती हैं।',
    safetySub: 'यहाँ का ज़्यादातर इंजीनियरिंग उसी में गया जो Vani नहीं करेगी।',
    safetyRedK: 'रेड फ्लैग',
    safetyRedP: 'इमरजेंसी वाक्य के बीच में भी पहले आती है। न्यूट्रोपीनिया में बुखार, साँस फूलना, भारी खून बहना, ट्रांसप्लांट के बाद GVHD के संकेत: पहला वाक्य उन्हें इमरजेंसी भेजता है, और बाकी चर्चा नहीं होती।',
    safetyInventK: 'कोई गढ़ंत नहीं',
    safetyInventP: 'कोई अस्पताल, डॉक्टर, कीमत, ट्रायल या इंतज़ार का समय कभी गढ़ा नहीं जाता। बुकिंग से पहले अस्पताल ByOnco के डेटाबेस से जाँचे जाते हैं। खर्च एक निश्चित कैलकुलेटर से आता है, अंदाज़े से नहीं।',
    safetyBoundK: 'सीमाएँ',
    safetyBoundP: 'कभी निदान नहीं, कभी डोज़ नहीं, कभी "यह दवा बंद करो" नहीं। वह बता सकती है रिपोर्ट के शब्द का मतलब; यह नहीं बताएगी कि आपकी रिपोर्ट का मतलब क्या है। वह आपके ऑन्कोलॉजिस्ट का काम है।',
    safetyDistressK: 'संकट',
    safetyDistressP: 'निराशा का जवाब देखभाल से, रीडायरेक्ट से नहीं। अमेरिका: 988 और 911। भारत: 108। जहाँ नंबर जाँच नहीं सकते, गढ़ने के बजाय वही कहते हैं।',
    safetyPrivK: 'गोपनीयता',
    safetyPrivP: 'आपकी यादें आपकी हैं। Vani जो जानती है वह ऐप में दिखता है, संपादन योग्य है, और एक टैप में मिटता है।',
    planFree2: 'सभी {n} भाषाएँ',
    planPro1: '{n} भाषाओं में अनलिमिटेड सवाल',
    planPro2: 'अमेरिकी अस्पताल और NCI केंद्र मैचिंग',
    planPro3: '12 घंटे से कम में दूसरी राय',
    planPro4: 'खर्च अनुमान और इंश्योरेंस की भाषा',
    planPro5: 'चेक-इन, बुकमार्क और विश्लेषण',
    planLifeWho: 'एक भुगतान',
    planLife1: 'PRO की सब चीज़, हमेशा के लिए',
    planLife2: 'कोई रिन्यूअल नहीं',
    planLife3: 'उन परिवारों के लिए जो सालों इसमें हैं',
    saasLead: 'कैंसर केंद्र:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'अंतरराष्ट्रीय रेफ़रल, बेड और कतार एनालिटिक्स, कन्वर्ज़न ट्रैकिंग, EMR इंटीग्रेशन।',
    faq2q: 'आप इसे गढ़ने से कैसे रोकते हैं?',
    faq2a: 'अस्पताल, डॉक्टर, कीमतें, ट्रायल और इंतज़ार का समय सबसे जोखिम भरी चीज़ें हैं जो कोई मॉडल गढ़ सकता है, इसलिए वह इन्हें याद से नहीं बना सकती। अस्पताल के नाम ByOnco की जाँची डायरेक्टरी से जुड़ते हैं, पहले अमेरिकी NCI केंद्र। खर्च निश्चित कैलकुलेटर से आता है। जहाँ नहीं जानती, कह देती है।',
    faq3q: 'मेरी मेडिकल जानकारी का क्या होता है?',
    faq3a: 'Vani आपके बारे में जो याद रखती है वह ऐप में दिखता है, पंक्ति-दर-पंक्ति संपादन योग्य है, और एक टैप में मिटता है। हम स्वास्थ्य डेटा नहीं बेचते। अमेरिकी उपयोगकर्ता HIPAA-ready मुद्रा में; भारत में DPDP Act भी लागू है।',
    faq4a: '{n} भाषाओं में लिखकर पूछें। अमेरिका के लिए अंग्रेज़ी डिफ़ॉल्ट है।',
    servicesH2: 'पूरी कैंसर देखभाल, बातचीत से आगे',
    servicesLead: 'ByOnco आपको अमेरिकी अस्पतालों, USD खर्च तालिकाओं, दुर्लभ कैंसर मार्गों, दूसरी राय और केयर पैकेज से जोड़ता है।',
    howByoncoLead: 'मैचिंग से इंश्योरेंस मदद तक। कैंसर यात्रा ऐसे गाइड करते हैं।',
    specializedCare: 'विशेष देखभाल',
    rareUltraH2: 'दुर्लभ और अति-दुर्लभ कैंसर विशेषज्ञता',
    rareSpecialize: 'हम {n} दुर्लभ कैंसर प्रकारों में विशेषज्ञ हैं',
    rareMapped: ', {n} केंद्रों में मैप किए गए।',
    viewRare: 'सभी दुर्लभ कैंसर देखें',
    fullMarketplace: 'पूरा केयर मार्केटप्लेस',
    teamEyebrow: 'विश्वस्तरीय टीम ने बनाया',
    teamTag: 'ऐसे लोगों ने बनाया जो दर्द समझते हैं, ऐसे लोगों से चलता है जो उसे सुलझा सकते हैं',
    hospTitle: 'अस्पतालों के लिए',
    hospDesc: 'Hospital SaaS $10,000 प्रति महीना: योग्य अंतरराष्ट्रीय रेफ़रल, कन्वर्ज़न ट्रैकिंग, बेड और कतार एनालिटिक्स, EMR इंटीग्रेशन।',
    hospPill: 'Hospital SaaS',
    hospH1: 'एक B2B दरवाज़ा जो माइक्रोफ़ोन के पीछे नहीं छिपता।',
    hospLede: 'योग्य अंतरराष्ट्रीय रेफ़रल, कन्वर्ज़न ट्रैकिंग, बेड और कतार एनालिटिक्स, और EMR इंटीग्रेशन। आउटबाउंड यही भेजता है। पार्टनर को बिज़नेस देखने के लिए वॉइस डेमो पार नहीं करना पड़ता।',
    hospMarketplace: 'केयर मार्केटप्लेस देखें',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS $10,000 प्रति महीना।',
    hospSkuSub: 'लाइव। वेटलिस्ट नहीं। बाकी ByOnco जैसा ही भुगतान पथ।',
    hospRefH: 'अंतरराष्ट्रीय रेफ़रल',
    hospRefP: 'दस्तावेज़ पैकेट वाले योग्य इनबाउंड केस, ब्रोशर साइट और उम्मीद नहीं।',
    hospBedsH: 'बेड, कतार, कन्वर्ज़न',
    hospBedsP: 'कौन से रेफ़रल कन्वर्ट होते हैं, कहाँ अटकते हैं, और कोऑर्डिनेटर को अभी क्या चाहिए।',
    hospEmrH: 'EMR इंटीग्रेशन',
    hospEmrP: 'अकाउंट-मैनेज्ड ऑनबोर्डिंग। समर्पित सपोर्ट। वन-हरा दरवाज़ा नेव और फ़ुटर में प्रथम श्रेणी रहता है।',
    hospPartners: 'पार्टनरशिप से बात करें',
  },
  fr: {
    openTheApp: 'Commencer gratuitement',
    langStatWrite: 'langues pour écrire',
    langStatSpeak: 'langues pour parler',
    trainedOncologists: 'formée par des oncologues',
    footerDisclaimer: "Vani donne des informations générales sur le cancer et les soins. Elle ne diagnostique pas, ne prescrit pas et ne remplace pas votre oncologue.",
    footerEmergency: "Aux États-Unis, en urgence composez le 911 ; pour une crise, appelez ou envoyez un SMS au 988.",
    speakInLangs: 'Parlez dans n’importe laquelle des {n} langues.',
    problemEyebrow: 'Le problème',
    problemP1: 'Mardi au Memorial Hermann à Houston : vingt minutes, puis l’oncologue est parti jusqu’à jeudi. À 2 h 14 du matin à Sugar Land, sa fille a la note du portail ouverte sur le sol de la chambre d’amis, et cherche ce que sa mère peut manger sous FOLFOX. Les premiers résultats sont des pages du NHS.',
    problemP2: 'Le médecin est déjà rentré. Celle qui doit décider du dîner, et d’une fièvre à 101, est la fille qui a conduit.',
    problemQuote: 'Elle est sous FOLFOX ce cycle. Qu’est-ce que je lui donne vraiment à manger, et quand une fièvre, c’est les urgences ?',
    problemAttr: 'Sugar Land, Texas. 2 h 14 du matin, deux nuits après la perfusion au Memorial Hermann.',
    howEyebrow: 'Comment ça marche',
    howSub: 'Pas de formulaires, pas de menus. L’écrit fonctionne déjà en {n} langues.',
    howAskH: 'Demandez avec vos mots',
    howAskP: 'Écrivez comme vous parlez, dans n’importe laquelle des {n} langues. Laissez chemotherapy et platelets en anglais. L’anglais est la langue par défaut pour les soins aux États-Unis.',
    howAnswerH: 'Une réponse courte et humaine',
    howAnswerP: 'Deux ou trois phrases, comme quelqu’un assis en face. Pas un mur de texte, pas une liste de mises en garde, et jamais un diagnostic.',
    howRememberH: 'Elle se souvient',
    howRememberP: 'Le type de cancer, le régime, le cycle, votre ville, si vous êtes le patient ou le fils. Revenez la semaine suivante et vous continuez. Personne n’explique deux fois le diagnostic de sa mère à une machine.',
    langEyebrow: 'Langues',
    scopeEyebrow: 'Couverture',
    scopeH2: 'Les types de cancer, et toute la vie autour.',
    scopeH2n: '{n} types de cancer, et toute la vie autour.',
    scopeSub: 'Y compris les rares, là où les familles ont le moins d’aide et en ont le plus besoin.',
    cardTreatH: 'Traitement et greffe',
    cardWarnH: 'Ce dont personne ne prévient',
    cardMoneyH: 'Argent et logistique',
    cardRareH: 'Cancers rares, sans haussement d’épaules',
    cardCareH: 'Pour la personne à côté',
    cardRefuseH: 'Ce qu’elle refuse',
    safetyEyebrow: 'Sécurité',
    safetyH2: 'Conçue par des gens qui supposent qu’elle sera utilisée à 3 h du matin, par quelqu’un qui a peur.',
    safetySub: 'Une grande partie de l’ingénierie sert à ce que Vani ne fera pas.',
    safetyRedK: 'Signaux d’alerte',
    safetyInventK: 'Pas d’invention',
    safetyBoundK: 'Limites',
    safetyDistressK: 'Détresse',
    safetyPrivK: 'Confidentialité',
    priceEyebrow: 'Tarifs',
    priceSub: 'Forfaits à partir de 14,99 $ par mois, au lieu de 39,99 $. Sans engagement.',
    planFree: 'Gratuit',
    planFreeWho: 'Essayez d’abord',
    planFree1: '2 questions, sans carte',
    planFree2: 'Les {n} langues',
    planFree3: 'Formée par des oncologues expérimentés',
    planProWho: 'Patients et familles',
    planProTag: 'La plupart des familles choisissent ceci',
    planPro1: 'Questions illimitées en {n} langues',
    planPro2: 'Appariement hôpitaux US et centres NCI',
    planPro3: 'Seconds avis en moins de 12 heures',
    planPro4: 'Estimations de coûts et cadre d’assurance',
    planPro5: 'Suivis, favoris et analyses',
    startPro: 'Commencer PRO',
    planLife: 'À vie',
    planLifeWho: 'Un seul paiement',
    planLife1: 'Tout de PRO, pour toujours',
    planLife2: 'Pas de renouvellements',
    planLife3: 'Pour les familles qui seront là des années',
    getLifetime: 'Obtenir à vie',
    saasLead: 'Centres de cancer :',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'pour les référencements internationaux, l’analytique des lits et des files, le suivi de conversion et l’intégration EMR.',
    requestDemo: 'Demander une démo',
    faqEyebrow: 'Questions',
    faqH2: 'Ce que les gens nous demandent d’abord.',
    faq1q: 'Est-ce un remplacement d’oncologue ?',
    faq1a: 'Non, et c’est construit pour ne pas le devenir. Vani ne diagnostique jamais, ne donne jamais une dose, et ne dit jamais de commencer, d’arrêter ou de changer un traitement. Elle répond aux questions entre les visites aux États-Unis, pour que les vingt minutes avec votre oncologue aillent à ce qui en a vraiment besoin.',
    faq4q: 'Est-ce que ça marche seulement en anglais ?',
    faq4a: 'Écrivez dans {n} langues. L’anglais est la langue par défaut aux États-Unis.',
    faq5q: 'Pour qui est-ce ?',
    faq5a: 'Les patients et les aidants. La personne dans le fauteuil de perfusion, la fille qui conduit à l’hôpital, le conjoint qui cherche quelque chose à 2 h du matin. Si le cancer fait partie de votre vie, c’est pour vous.',
    closeH2: 'Personne ne devrait affronter cela entre jeudi et le prochain message du portail.',
    servicesH2: 'Des soins complets, au-delà de la conversation',
    servicesLead: 'ByOnco vous relie aux hôpitaux américains, aux tableaux de coûts en USD, aux parcours de cancers rares, aux seconds avis et aux forfaits de soins.',
    howByoncoH2: 'Comment ByOnco fonctionne',
    howByoncoLead: 'De l’appariement à l’aide à l’assurance. Voici comment nous guidons le parcours.',
    specializedCare: 'Soins spécialisés',
    rareUltraH2: 'Expertise cancers rares et ultra-rares',
    rareSpecialize: 'Nous nous spécialisons dans {n} types de cancers rares',
    rareMapped: ', cartographiés dans {n} centres.',
    viewRare: 'Voir tous les cancers rares',
    fullMarketplace: 'Marché de soins complet',
    teamEyebrow: 'Conçu par une équipe de premier plan',
    teamTag: 'Conçu par des gens qui comprennent la douleur, porté par des gens qui peuvent la résoudre',
    hospTitle: 'Pour les hôpitaux',
    hospDesc: 'Hospital SaaS à 10 000 $ par mois : référencements internationaux qualifiés, suivi de conversion, analytique des lits et des files, intégration EMR.',
    hospPill: 'Hospital SaaS',
    hospH1: 'Une porte B2B qui ne se cache pas derrière un micro.',
    hospLede: 'Référencements internationaux qualifiés, suivi de conversion, analytique des lits et des files, et intégration EMR. C’est ce que l’outbound envoie. Les partenaires n’ont pas à dépasser une démo vocale pour voir une entreprise.',
    hospMarketplace: 'Voir le marché de soins',
    hospSkuEyebrow: 'Le SKU',
    hospSkuH2: 'Hospital SaaS à 10 000 $ par mois.',
    hospSkuSub: 'En ligne. Pas une liste d’attente. Le même parcours de paiement que le reste de ByOnco.',
    hospRefH: 'Référencements internationaux',
    hospRefP: 'Dossiers entrants qualifiés avec paquets de documents, pas un site brochure et un espoir.',
    hospBedsH: 'Lits, files, conversion',
    hospBedsP: 'Voyez quels référencements convertissent, où ils bloquent, et ce qu’il manque encore au coordinateur.',
    hospEmrH: 'Intégration EMR',
    hospEmrP: 'Onboarding géré par compte. Support dédié. La porte vert forêt reste de premier plan dans la navigation et le pied de page.',
    hospPartners: 'Parler aux partenariats',
  },
  de: {
    openTheApp: 'Kostenlos starten',
    langStatWrite: 'Sprachen zum Schreiben',
    langStatSpeak: 'Sprachen zum Sprechen',
    trainedOncologists: 'von Onkologen ausgebildet',
    footerBlurb: 'Ein onkologischer Begleiter für Patientinnen, Patienten und Familien, in der Sprache, in der Sie denken.',
    footerDisclaimer: 'Vani gibt allgemeine Informationen zu Krebs und Krebsversorgung. Sie diagnostiziert nicht, verschreibt nicht und ersetzt nicht Ihren Onkologen.',
    footerEmergency: 'In den USA bei Notfällen 911; bei einer Krise 988 anrufen oder SMS senden.',
    speakInLangs: 'Sprechen Sie in einer von {n} Sprachen.',
    cancerTypesCovered: 'abgedeckte Krebsarten',
    hospitalsMapped: 'erfasste Krankenhäuser',
    secondOpinions: 'fachliche Zweitmeinungen',
    problemEyebrow: 'Das Problem',
    problemP1: 'Dienstag am Memorial Hermann in Houston: zwanzig Minuten, dann ist der Onkologe bis Donnerstag weg. Um 2:14 Uhr in Sugar Land hat die Tochter die Portalnotiz auf dem Gästezimmerboden offen und googelt, was die Mutter unter FOLFOX essen darf. Die ersten Treffer sind NHS-Seiten.',
    problemP2: 'Der Arzt ist schon nach Hause. Wer über das Abendessen entscheidet, und über Fieber von 101, ist die Tochter, die gefahren ist.',
    problemQuote: 'Sie ist in diesem Zyklus auf FOLFOX. Was gebe ich ihr wirklich zu essen, und wann ist Fieber ein ER-Besuch?',
    problemAttr: 'Sugar Land, Texas. 2:14 Uhr, zwei Nächte nach der Infusion am Memorial Hermann.',
    howEyebrow: 'So funktioniert es',
    howSub: 'Keine Formulare, keine Menüs. Schreiben funktioniert bereits in {n} Sprachen.',
    howAskH: 'Fragen Sie in Ihren Worten',
    howAskP: 'Schreiben Sie, wie Sie sprechen, in einer von {n} Sprachen. Lassen Sie chemotherapy und platelets auf Englisch. Englisch ist die Standardprache für die Versorgung in den USA.',
    howAnswerH: 'Eine kurze, menschliche Antwort',
    howAnswerP: 'Zwei oder drei Sätze, wie jemand am Tisch gegenüber. Keine Textwand, keine Liste von Vorbehalten, und nie eine Diagnose.',
    howRememberH: 'Sie erinnert sich',
    howRememberP: 'Die Krebsart, das Regime, welcher Zyklus, Ihre Stadt, ob Sie Patient oder Sohn sind. Nächste Woche kommen Sie wieder und machen weiter. Niemand erklärt die Diagnose der Mutter zweimal einer Maschine.',
    langEyebrow: 'Sprachen',
    scopeEyebrow: 'Abdeckung',
    scopeH2: 'Krebsarten, und das ganze Leben darum herum.',
    scopeH2n: '{n} Krebsarten, und das ganze Leben darum herum.',
    scopeSub: 'Einschließlich der seltenen, bei denen Familien meist die wenigste Hilfe bekommen und die meiste brauchen.',
    cardTreatH: 'Behandlung und Transplantation',
    cardWarnH: 'Wovor niemand warnt',
    cardMoneyH: 'Geld und Logistik',
    cardRareH: 'Seltene Krebse, ohne Schulterzucken',
    cardCareH: 'Für die Person daneben',
    cardRefuseH: 'Was sie ablehnt',
    safetyEyebrow: 'Sicherheit',
    safetyH2: 'Gebaut von Leuten, die annehmen, dass es um 3 Uhr nachts benutzt wird, von jemandem mit Angst.',
    safetySub: 'Viel Engineering ging in das, was Vani nicht tun wird.',
    safetyRedK: 'Warnsignale',
    safetyInventK: 'Keine Erfindung',
    safetyBoundK: 'Grenzen',
    safetyDistressK: 'Not',
    safetyPrivK: 'Privatsphäre',
    priceEyebrow: 'Preise',
    priceSub: 'Tarife ab 14,99 $ im Monat, reduziert von 39,99 $. Jederzeit kündbar.',
    planFree: 'Kostenlos',
    planFreeWho: 'Zuerst ausprobieren',
    planFree1: '2 Fragen, keine Karte',
    planFree2: 'Alle {n} Sprachen',
    planFree3: 'Ausgebildet von erfahrenen Onkologen',
    planProWho: 'Patienten und Familien',
    planProTag: 'Die meisten Familien wählen das',
    planPro1: 'Unbegrenzte Fragen in {n} Sprachen',
    startPro: 'PRO starten',
    planLife: 'Lebenslang',
    getLifetime: 'Lebenslang holen',
    saasLead: 'Krebszentren:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'für internationale Überweisungen, Bett- und Warteschlangenanalytik, Conversion-Tracking, EMR-Integration.',
    requestDemo: 'Demo anfragen',
    faqEyebrow: 'Fragen',
    faqH2: 'Was uns zuerst gefragt wird.',
    faq1q: 'Ist das ein Ersatz für einen Onkologen?',
    faq4q: 'Geht das nur auf Englisch?',
    faq4a: 'Schreiben Sie in {n} Sprachen. Englisch ist die Standardprache für die USA.',
    faq5q: 'Für wen ist das?',
    closeH2: 'Niemand sollte das zwischen Donnerstag und der nächsten Portalnachricht allein schaffen müssen.',
    servicesH2: 'Vollständige Krebsversorgung, über das Gespräch hinaus',
    servicesLead: 'ByOnco verbindet Sie mit US-Krankenhäusern, USD-Kostentabellen, seltenen Krebspfaden, Zweitmeinungen und Versorgungspaketen.',
    howByonco: 'So funktioniert ByOnco',
    howByoncoH2: 'So funktioniert ByOnco',
    specializedCare: 'Spezialisierte Versorgung',
    rareUltraH2: 'Expertise für seltene und ultra-seltene Krebse',
    rareSpecialize: 'Wir spezialisieren uns auf {n} seltene Krebsarten',
    rareMapped: ', erfasst an {n} Zentren.',
    viewRare: 'Alle seltenen Krebse ansehen',
    fullMarketplace: 'Voller Versorgungsmarktplatz',
    teamEyebrow: 'Gebaut von einem erstklassigen Team',
    teamTag: 'Gebaut von Menschen, die den Schmerz verstehen, getragen von Menschen, die ihn lösen können',
    hospTitle: 'Für Krankenhäuser',
    hospDesc: 'Hospital SaaS für 10.000 $ im Monat: qualifizierte internationale Überweisungen, Conversion-Tracking, Bett- und Warteschlangenanalytik und EMR-Integration.',
    hospPill: 'Hospital SaaS',
    hospH1: 'Eine B2B-Tür, die sich nicht hinter einem Mikrofon versteckt.',
    hospLede: 'Qualifizierte internationale Überweisungen, Conversion-Tracking, Bett- und Warteschlangenanalytik und EMR-Integration. Das schickt Outbound. Partner müssen nicht an einer Sprachdemo vorbeiscrollen, um ein Geschäft zu sehen.',
    hospMarketplace: 'Den Versorgungsmarktplatz sehen',
    hospSkuEyebrow: 'Das SKU',
    hospSkuH2: 'Hospital SaaS für 10.000 $ im Monat.',
    hospSkuSub: 'Live. Keine Warteliste. Derselbe Zahlungsweg wie der Rest von ByOnco.',
    hospRefH: 'Internationale Überweisungen',
    hospRefP: 'Qualifizierte eingehende Fälle mit Dokumentenpaketen, keine Broschürenseite und eine Hoffnung.',
    hospBedsH: 'Betten, Warteschlangen, Conversion',
    hospBedsP: 'Sehen Sie, welche Überweisungen konvertieren, wo sie stocken, und was der Koordinator noch braucht.',
    hospEmrH: 'EMR-Integration',
    hospEmrP: 'Kontoverwaltetes Onboarding. Dedizierter Support. Die waldgrüne Tür bleibt in Navigation und Fußzeile erstklassig.',
    hospPartners: 'Mit Partnerships sprechen',
  },
  zh: {
    openTheApp: '免费开始',
    langStatWrite: '可书写的语言',
    langStatSpeak: '可开口的语言',
    trainedOncologists: '由肿瘤科医生训练',
    footerDisclaimer: 'Vani 提供关于癌症和癌症照护的一般信息。她不做诊断、不开药，也不能替代你的肿瘤科医生。',
    footerEmergency: '美国紧急情况请打 911；危机支持请致电或短信 988。',
    speakInLangs: '用 {n} 种语言开口说。',
    howSub: '没有表格，没有菜单。书写已支持 {n} 种语言。',
    howAskH: '用你自己的话说',
    howAskP: '怎么想就怎么写，可用 {n} 种语言。chemotherapy 和 platelets 请留英文。美国就医默认英语。',
    howAnswerH: '简短、像人说的回答',
    howAnswerP: '两三句话，像坐在对面的人解释。不是一堵字墙，不是一串免责，也绝不是诊断。',
    howRememberH: '她记得',
    howRememberP: '癌症类型、方案、第几个周期、你的城市、你是患者还是儿子。下周再来，接着说。没有人要把母亲的诊断向机器解释两次。',
    langEyebrow: '语言',
    scopeEyebrow: '覆盖范围',
    scopeH2: '癌症类型，以及围绕它们的整段生活。',
    scopeH2n: '{n} 种癌症类型，以及围绕它们的整段生活。',
    scopeSub: '包括罕见的那些：家人通常得到最少帮助、却最需要帮助。',
    cardTreatH: '治疗与移植',
    cardWarnH: '没人预先提醒的那些',
    cardMoneyH: '钱和后勤',
    cardRareH: '罕见癌症，没有耸肩',
    cardCareH: '给旁边那个人',
    cardRefuseH: '她拒绝什么',
    safetyEyebrow: '安全',
    safetyH2: '由假定凌晨 3 点会有人带着恐惧来用的人建造。',
    safetySub: '大部分工程花在 Vani 不会做的事上。',
    safetyRedK: '危险信号',
    safetyInventK: '不编造',
    safetyBoundK: '边界',
    safetyDistressK: 'Distress',
    safetyPrivK: '隐私',
    priceEyebrow: '价格',
    priceSub: '方案每月 $14.99 起，原价 $39.99。可随时取消。',
    planFree: '免费',
    planFreeWho: '先试用',
    planFree1: '2 个问题，不用卡',
    planFree2: '全部 {n} 种语言',
    planFree3: '由有经验的肿瘤科医生训练',
    planProWho: '患者和家人',
    planProTag: '多数家庭选这个',
    planPro1: '{n} 种语言不限次数提问',
    startPro: '开始 PRO',
    planLife: '终身',
    getLifetime: '获取终身',
    saasLead: '癌症中心：',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: '用于国际转诊、床位和排队分析、转化跟踪、EMR 集成。',
    requestDemo: '申请演示',
    faqEyebrow: '问题',
    faqH2: '人们最先问我们的。',
    faq1q: '这能替代肿瘤科医生吗？',
    faq4q: '只能用英语吗？',
    faq4a: '可用 {n} 种语言书写。美国默认英语。',
    faq5q: '这是给谁的？',
    closeH2: '不该有人在周四和下一条门户消息之间独自面对这些。',
    servicesH2: '完整的癌症照护，不止于对话',
    servicesLead: 'ByOnco 为你匹配美国医院、美元费用表、罕见癌症路径、第二意见和照护套餐。',
    howByonco: 'ByOnco 如何运作',
    howByoncoH2: 'ByOnco 如何运作',
    specializedCare: '专科照护',
    rareUltraH2: '罕见与超罕见癌症专长',
    rareSpecialize: '我们专长于 {n} 种罕见癌症类型',
    rareMapped: '，覆盖 {n} 家中心。',
    viewRare: '查看全部罕见癌症',
    fullMarketplace: '完整照护市场',
    teamEyebrow: '由世界级团队打造',
    teamTag: '由理解痛苦的人打造，由能解决问题的人驱动',
    hospTitle: '医院合作',
    hospDesc: 'Hospital SaaS 每月 $10,000：合格国际转诊、转化跟踪、床位和排队分析、EMR 集成。',
    hospPill: 'Hospital SaaS',
    hospH1: '一扇不躲在麦克风后面的 B2B 门。',
    hospLede: '合格国际转诊、转化跟踪、床位和排队分析、以及 EMR 集成。对外发出的就是这些。合作方不必翻过语音演示才看到生意。',
    hospMarketplace: '查看照护市场',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS 每月 $10,000。',
    hospSkuSub: '已上线。不是候补名单。与 ByOnco 其余产品同一条付费路径。',
    hospRefH: '国际转诊',
    hospRefP: '带完整材料包的合格入库病例，不是宣传页加一句希望。',
    hospBedsH: '床位、排队、转化',
    hospBedsP: '看哪些转诊转化、卡在哪里、协调员还缺什么。',
    hospEmrH: 'EMR 集成',
    hospEmrP: '客户经理式接入。专属支持。森林绿的门在导航和页脚保持一等位置。',
    hospPartners: '联系合作团队',
  },
  ja: {
    openTheApp: '無料で始める',
    langStatWrite: '書ける言語',
    langStatSpeak: '話せる言語',
    trainedOncologists: '腫瘍医が訓練',
    footerBlurb: '患者と家族のための腫瘍領域の相棒。本当に考えている言語で。',
    footerDisclaimer: 'Vaniはがんとがん治療に関する一般情報を提供します。診断せず、処方せず、主治医の腫瘍医の代わりにはなりません。',
    footerEmergency: '米国の緊急時は911。危機支援は988に電話またはテキスト。',
    speakInLangs: '{n}の言語で話せます。',
    cancerTypesCovered: '対象のがん種',
    hospitalsMapped: '収録病院',
    secondOpinions: '専門のセカンドオピニオン',
    problemEyebrow: '課題',
    howEyebrow: '使い方',
    howSub: 'フォームもメニューもありません。文字での質問はすでに{n}言語に対応しています。',
    howAskH: '自分の言葉で聞く',
    howAskP: '話すように書いてください。{n}言語どれでも。chemotherapyとplateletsは英語のまま。米国のケアでは英語が初期設定です。',
    howAnswerH: '短く、人らしい答え',
    howRememberH: '彼女は覚えている',
    langEyebrow: '言語',
    scopeEyebrow: 'カバー範囲',
    scopeH2: 'がんの種類と、その周りの生活全部。',
    scopeH2n: '{n}のがん種と、その周りの生活全部。',
    cardTreatH: '治療と移植',
    cardWarnH: '誰も事前に言わないこと',
    cardMoneyH: 'お金と手続き',
    cardRareH: '希少がん、肩をすくめずに',
    cardCareH: '隣にいる人のために',
    cardRefuseH: '彼女が拒むこと',
    safetyEyebrow: '安全',
    safetyH2: '午前3時、怖がっている人が使う前提で作られています。',
    safetyRedK: '危険信号',
    safetyInventK: '創作しない',
    safetyBoundK: '境界',
    safetyDistressK: 'Distress',
    safetyPrivK: 'プライバシー',
    priceEyebrow: '料金',
    priceSub: '月額14.99ドルから（元値39.99ドル）。いつでもキャンセル可能。',
    planFree: '無料',
    planFreeWho: 'まず試す',
    planFree1: '質問2つ、カード不要',
    planFree2: '{n}言語すべて',
    planProWho: '患者と家族',
    planProTag: '多くの家族がこれを選ぶ',
    planPro1: '{n}言語で質問し放題',
    startPro: 'PROを始める',
    planLife: '生涯',
    getLifetime: '生涯プランを取る',
    saasLead: 'がんセンター：',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: '国際紹介、ベッドと待ち行列の分析、コンバージョン追跡、EMR連携。',
    requestDemo: 'デモを依頼',
    faqEyebrow: '質問',
    faqH2: '最初に聞かれること。',
    faq1q: '腫瘍医の代わりですか？',
    faq4q: '英語だけですか？',
    faq4a: '{n}言語で書いて質問できます。米国では英語が初期設定です。',
    faq5q: '誰のためのものですか？',
    closeH2: '木曜日から次のポータルメッセージまでのあいだ、誰も一人で向き合わなくていい。',
    servicesH2: '会話の先まで、がんケア一式',
    servicesLead: 'ByOncoは米国の病院、米ドルの費用表、希少がんの経路、セカンドオピニオン、ケアパッケージにつなぎます。',
    howByonco: 'ByOncoの仕組み',
    howByoncoH2: 'ByOncoの仕組み',
    specializedCare: '専門ケア',
    rareUltraH2: '希少・超希少がんの専門性',
    rareSpecialize: '{n}の希少がん種を専門にしています',
    rareMapped: '、{n}のセンターにマッピング。',
    viewRare: '希少がんをすべて見る',
    fullMarketplace: 'ケアマーケットプレイス全体',
    teamEyebrow: '世界水準のチームが構築',
    teamTag: '痛みを知る人が作り、解ける人が動かしている',
    hospTitle: '病院の方へ',
    hospDesc: 'Hospital SaaS 月額1万ドル。適格な国際紹介、コンバージョン追跡、ベッドと待ち行列の分析、EMR連携。',
    hospPill: 'Hospital SaaS',
    hospH1: 'マイクの後ろに隠れないB2Bの入口。',
    hospLede: '適格な国際紹介、コンバージョン追跡、ベッドと待ち行列の分析、EMR連携。対外に出すのはこれです。パートナーは音声デモを通り過ぎなくても事業が見えます。',
    hospMarketplace: 'ケアマーケットプレイスを見る',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS 月額1万ドル。',
    hospSkuSub: '稼働中。ウェイトリストではない。ByOncoの他と同じ支払い経路。',
    hospRefH: '国際紹介',
    hospRefP: '資料一式つきの適格な受入症例。パンフレットサイトと希望だけではない。',
    hospBedsH: 'ベッド、待ち行列、コンバージョン',
    hospBedsP: 'どの紹介が成約し、どこで止まり、コーディネーターにまだ何が足りないか。',
    hospEmrH: 'EMR連携',
    hospEmrP: 'アカウント担当のオンボーディング。専任サポート。フォレストグリーンの入口はナビとフッターで第一級のまま。',
    hospPartners: 'パートナーシップに話す',
  },
  ko: {
    openTheApp: '무료로 시작하기',
    langStatWrite: '글로 쓸 수 있는 언어',
    langStatSpeak: '말로 할 수 있는 언어',
    trainedOncologists: '종양 전문의가 훈련',
    footerBlurb: '환자와 가족을 위한 종양학 동반자. 실제로 생각하는 언어로.',
    footerDisclaimer: 'Vani는 암과 암 치료에 대한 일반 정보를 제공합니다. 진단하지 않고, 처방하지 않으며, 담당 종양 전문의를 대체하지 않습니다.',
    footerEmergency: '미국 응급은 911, 위기 지원은 988로 전화 또는 문자.',
    speakInLangs: '{n}개 언어로 말하세요.',
    cancerTypesCovered: '다루는 암 종류',
    hospitalsMapped: '매핑된 병원',
    secondOpinions: '전문가 세컨드 오피니언',
    problemEyebrow: '문제',
    howEyebrow: '이용 방법',
    howSub: '양식도 메뉴도 없습니다. 글쓰기는 이미 {n}개 언어로 됩니다.',
    howAskH: '자기 말로 묻기',
    howAskP: '말하듯 쓰세요. {n}개 언어 중 아무거나. chemotherapy와 platelets는 영어로 두세요. 미국 진료의 기본은 영어입니다.',
    howAnswerH: '짧고 사람 같은 답',
    howRememberH: '그녀는 기억합니다',
    langEyebrow: '언어',
    scopeEyebrow: '범위',
    scopeH2: '암 종류, 그리고 그 주변의 삶 전부.',
    scopeH2n: '{n}가지 암 종류, 그리고 그 주변의 삶 전부.',
    cardTreatH: '치료와 이식',
    cardWarnH: '아무도 미리 말해주지 않는 것',
    cardMoneyH: '돈과 물류',
    cardRareH: '희귀암, 어깨를 으쓱하지 않고',
    cardCareH: '옆에 있는 사람을 위해',
    cardRefuseH: '그녀가 거부하는 것',
    safetyEyebrow: '안전',
    safetyH2: '새벽 3시, 겁에 질린 사람이 쓴다고 가정하고 만들었습니다.',
    safetyRedK: '위험 신호',
    safetyInventK: '지어내지 않음',
    safetyBoundK: '경계',
    safetyDistressK: 'Distress',
    safetyPrivK: '개인정보',
    priceEyebrow: '요금',
    priceSub: '월 $14.99부터 시작, 원래 $39.99. 언제든 취소 가능.',
    planFree: '무료',
    planFreeWho: '먼저 써 보기',
    planFree1: '질문 2개, 카드 없음',
    planFree2: '{n}개 언어 모두',
    planProWho: '환자와 가족',
    planProTag: '대부분 가족이 이것을 고릅니다',
    planPro1: '{n}개 언어로 무제한 질문',
    startPro: 'PRO 시작',
    planLife: '평생',
    getLifetime: '평생 플랜 받기',
    saasLead: '암 센터:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: '국제 의뢰, 병상과 대기열 분석, 전환 추적, EMR 연동.',
    requestDemo: '데모 요청',
    faqEyebrow: '질문',
    faqH2: '사람들이 먼저 묻는 것.',
    faq1q: '종양 전문의를 대체하나요?',
    faq4q: '영어만 되나요?',
    faq4a: '{n}개 언어로 글로 질문하세요. 미국에서는 영어가 기본입니다.',
    faq5q: '누구를 위한 건가요?',
    closeH2: '목요일과 다음 포털 메시지 사이에 혼자 맞서게 두지 마세요.',
    servicesH2: '대화를 넘어선 완전한 암 케어',
    servicesLead: 'ByOnco는 미국 병원, 달러 비용표, 희귀암 경로, 세컨드 오피니언, 케어 패키지로 연결합니다.',
    howByonco: 'ByOnco 이용 방법',
    howByoncoH2: 'ByOnco 이용 방법',
    specializedCare: '전문 케어',
    rareUltraH2: '희귀·초희귀암 전문성',
    rareSpecialize: '{n}가지 희귀암 종류를 전문으로 합니다',
    rareMapped: ', {n}개 센터에 매핑됨.',
    viewRare: '모든 희귀암 보기',
    fullMarketplace: '전체 케어 마켓플레이스',
    teamEyebrow: '세계적 팀이 만들었습니다',
    teamTag: '고통을 아는 사람이 만들고, 풀 수 있는 사람이 움직입니다',
    hospTitle: '병원용',
    hospDesc: 'Hospital SaaS 월 $10,000. 적격 국제 의뢰, 전환 추적, 병상과 대기열 분석, EMR 연동.',
    hospPill: 'Hospital SaaS',
    hospH1: '마이크 뒤에 숨지 않는 B2B 문.',
    hospLede: '적격 국제 의뢰, 전환 추적, 병상과 대기열 분석, EMR 연동. 대외로 보내는 내용이 이것입니다. 파트너가 음성 데모를 넘겨야 사업을 보는 구조가 아닙니다.',
    hospMarketplace: '케어 마켓플레이스 보기',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS 월 $10,000.',
    hospSkuSub: '운영 중. 대기 명단이 아닙니다. ByOnco 나머지와 같은 결제 경로.',
    hospRefH: '국제 의뢰',
    hospRefP: '서류 묶음이 있는 적격 인바운드 사례. 브로슈어 사이트와 희망이 아닙니다.',
    hospBedsH: '병상, 대기열, 전환',
    hospBedsP: '어떤 의뢰가 전환되고, 어디서 멈추고, 코디네이터에게 아직 무엇이 필요한지.',
    hospEmrH: 'EMR 연동',
    hospEmrP: '계정 담당 온보딩. 전담 지원. 포레스트 그린 문은 내비게이션과 푸터에서 일급으로 남습니다.',
    hospPartners: '파트너십에 문의',
  },
  pt: {
    openTheApp: 'Começar grátis',
    langStatWrite: 'idiomas para escrever',
    langStatSpeak: 'idiomas para falar',
    trainedOncologists: 'treinada por oncologistas',
    footerBlurb: 'Uma companheira de oncologia para pacientes e famílias, no idioma em que você pensa.',
    footerDisclaimer: 'Vani oferece informação geral sobre câncer e cuidado. Não diagnostica, não prescreve e não substitui o seu oncologista.',
    footerEmergency: 'Nos EUA, em emergência ligue 911; em crise, ligue ou envie SMS para 988.',
    speakInLangs: 'Fale em qualquer um dos {n} idiomas.',
    cancerTypesCovered: 'tipos de câncer cobertos',
    hospitalsMapped: 'hospitais mapeados',
    secondOpinions: 'segundas opiniões especializadas',
    problemEyebrow: 'O problema',
    howEyebrow: 'Como funciona',
    howSub: 'Sem formulários, sem menus. A escrita já funciona em {n} idiomas.',
    howAskH: 'Pergunte com as suas palavras',
    howAskP: 'Escreva como fala, em qualquer um dos {n} idiomas. Deixe chemotherapy e platelets em inglês. O inglês é o padrão para o cuidado nos EUA.',
    howAnswerH: 'Uma resposta curta e humana',
    howRememberH: 'Ela lembra',
    langEyebrow: 'Idiomas',
    scopeEyebrow: 'Cobertura',
    scopeH2: 'Tipos de câncer, e a vida inteira ao redor.',
    scopeH2n: '{n} tipos de câncer, e a vida inteira ao redor.',
    cardTreatH: 'Tratamento e transplante',
    cardWarnH: 'O que ninguém avisa',
    cardMoneyH: 'Dinheiro e logística',
    cardRareH: 'Cânceres raros, sem dar de ombros',
    cardCareH: 'Para quem está ao lado',
    cardRefuseH: 'O que ela recusa',
    safetyEyebrow: 'Segurança',
    safetyH2: 'Feita por gente que assume que será usada às 3 da manhã, por alguém com medo.',
    safetyRedK: 'Sinais de alerta',
    safetyInventK: 'Sem invenção',
    safetyBoundK: 'Limites',
    safetyDistressK: 'Angústia',
    safetyPrivK: 'Privacidade',
    priceEyebrow: 'Preços',
    priceSub: 'Planos a partir de $14.99 por mês, de $39.99. Cancele quando quiser.',
    planFree: 'Grátis',
    planFreeWho: 'Experimente primeiro',
    planFree1: '2 perguntas, sem cartão',
    planFree2: 'Os {n} idiomas',
    planProWho: 'Pacientes e famílias',
    planProTag: 'A maioria das famílias escolhe isto',
    planPro1: 'Perguntas ilimitadas em {n} idiomas',
    startPro: 'Começar PRO',
    planLife: 'Vitalício',
    getLifetime: 'Obter vitalício',
    saasLead: 'Centros de câncer:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'para encaminhamentos internacionais, análise de leitos e filas, rastreamento de conversão e integração EMR.',
    requestDemo: 'Pedir uma demo',
    faqEyebrow: 'Perguntas',
    faqH2: 'O que as pessoas nos perguntam primeiro.',
    faq1q: 'Isto substitui um oncologista?',
    faq4q: 'Só funciona em inglês?',
    faq4a: 'Escreva em {n} idiomas. O inglês é o padrão para os EUA.',
    faq5q: 'Para quem é isto?',
    closeH2: 'Ninguém deveria enfrentar isto entre quinta-feira e a próxima mensagem do portal.',
    servicesH2: 'Cuidado oncológico completo, além da conversa',
    servicesLead: 'A ByOnco liga você a hospitais dos EUA, tabelas de custo em USD, vias de cânceres raros, segundas opiniões e pacotes de cuidado.',
    howByonco: 'Como a ByOnco funciona',
    howByoncoH2: 'Como a ByOnco funciona',
    specializedCare: 'Cuidado especializado',
    rareUltraH2: 'Especialidade em cânceres raros e ultra-raros',
    rareSpecialize: 'Somos especialistas em {n} tipos de câncer raro',
    rareMapped: ', mapeados em {n} centros.',
    viewRare: 'Ver todos os cânceres raros',
    fullMarketplace: 'Mercado de cuidado completo',
    teamEyebrow: 'Feito por uma equipe de primeiro nível',
    teamTag: 'Feito por gente que entende a dor, movido por gente que pode resolvê-la',
    hospTitle: 'Para hospitais',
    hospDesc: 'Hospital SaaS a $10,000 por mês: encaminhamentos internacionais qualificados, rastreamento de conversão, análise de leitos e filas, e integração EMR.',
    hospPill: 'Hospital SaaS',
    hospH1: 'Uma porta B2B que não se esconde atrás de um microfone.',
    hospLede: 'Encaminhamentos internacionais qualificados, rastreamento de conversão, análise de leitos e filas, e integração EMR. É isso que o outbound envia. Parceiros não precisam passar de um demo de voz para ver um negócio.',
    hospMarketplace: 'Ver o mercado de cuidado',
    hospSkuEyebrow: 'O SKU',
    hospSkuH2: 'Hospital SaaS a $10,000 por mês.',
    hospSkuSub: 'No ar. Não é lista de espera. O mesmo caminho de pagamento do resto da ByOnco.',
    hospRefH: 'Encaminhamentos internacionais',
    hospRefP: 'Casos de entrada qualificados com pacotes de documentos, não um site de folheto e uma esperança.',
    hospBedsH: 'Leitos, filas, conversão',
    hospBedsP: 'Veja quais encaminhamentos convertem, onde travam, e o que o coordenador ainda precisa.',
    hospEmrH: 'Integração EMR',
    hospEmrP: 'Onboarding gerido por conta. Suporte dedicado. A porta verde-floresta fica de primeira classe no nav e no rodapé.',
    hospPartners: 'Falar com parcerias',
  },
  ru: {
    openTheApp: 'Начать бесплатно',
    langStatWrite: 'языки для письма',
    langStatSpeak: 'языки для речи',
    trainedOncologists: 'обучена онкологами',
    footerBlurb: 'Онкологический спутник для пациентов и семей, на языке, на котором вы думаете.',
    footerDisclaimer: 'Vani даёт общую информацию о раке и уходе. Она не ставит диагноз, не назначает лекарства и не заменяет вашего онколога.',
    footerEmergency: 'В США при неотложке звоните 911; при кризисе звоните или пишите 988.',
    speakInLangs: 'Говорите на любом из {n} языков.',
    cancerTypesCovered: 'типы рака в охвате',
    hospitalsMapped: 'больницы в каталоге',
    secondOpinions: 'экспертные вторые мнения',
    problemEyebrow: 'Проблема',
    howEyebrow: 'Как это работает',
    howSub: 'Никаких форм и меню. Письмо уже работает на {n} языках.',
    howAskH: 'Спросите своими словами',
    howAskP: 'Пишите так, как говорите, на любом из {n} языков. chemotherapy и platelets оставьте по-английски. Для ухода в США английский стоит по умолчанию.',
    howAnswerH: 'Короткий человеческий ответ',
    howRememberH: 'Она помнит',
    langEyebrow: 'Языки',
    scopeEyebrow: 'Охват',
    scopeH2: 'Типы рака и вся жизнь вокруг них.',
    scopeH2n: '{n} типов рака и вся жизнь вокруг них.',
    cardTreatH: 'Лечение и трансплантация',
    cardWarnH: 'О чём никто не предупреждает',
    cardMoneyH: 'Деньги и логистика',
    cardRareH: 'Редкие раки без пожимания плечами',
    cardCareH: 'Для того, кто рядом',
    cardRefuseH: 'От чего она отказывается',
    safetyEyebrow: 'Безопасность',
    safetyH2: 'Сделана людьми, которые считают, что ею будут пользоваться в 3 часа ночи, со страхом.',
    safetyRedK: 'Красные флаги',
    safetyInventK: 'Без выдумки',
    safetyBoundK: 'Границы',
    safetyDistressK: 'Distress',
    safetyPrivK: 'Конфиденциальность',
    priceEyebrow: 'Цены',
    priceSub: 'Тарифы от $14.99 в месяц, вместо $39.99. Отмена в любое время.',
    planFree: 'Бесплатно',
    planFreeWho: 'Сначала попробовать',
    planFree1: '2 вопроса, без карты',
    planFree2: 'Все {n} языков',
    planProWho: 'Пациенты и семьи',
    planProTag: 'Большинство семей выбирают это',
    planPro1: 'Безлимитные вопросы на {n} языках',
    startPro: 'Начать PRO',
    planLife: 'Навсегда',
    getLifetime: 'Взять навсегда',
    saasLead: 'Онкоцентры:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'для международных направлений, аналитики коек и очередей, отслеживания конверсии и интеграции EMR.',
    requestDemo: 'Запросить демо',
    faqEyebrow: 'Вопросы',
    faqH2: 'Что нас спрашивают сначала.',
    faq1q: 'Это замена онкологу?',
    faq4q: 'Только на английском?',
    faq4a: 'Пишите на {n} языках. Для США английский стоит по умолчанию.',
    faq5q: 'Для кого это?',
    closeH2: 'Никто не должен оставаться с этим между четвергом и следующим сообщением портала.',
    servicesH2: 'Полная онкопомощь, дальше разговора',
    servicesLead: 'ByOnco подбирает больницы США, таблицы стоимости в USD, пути при редких раках, вторые мнения и пакеты помощи.',
    howByonco: 'Как работает ByOnco',
    howByoncoH2: 'Как работает ByOnco',
    specializedCare: 'Специализированная помощь',
    rareUltraH2: 'Экспертиза редких и ультраредких раков',
    rareSpecialize: 'Мы специализируемся на {n} редких типах рака',
    rareMapped: ', в {n} центрах.',
    viewRare: 'Смотреть все редкие раки',
    fullMarketplace: 'Полный рынок помощи',
    teamEyebrow: 'Сделано командой мирового уровня',
    teamTag: 'Сделано теми, кто понимает боль, движется теми, кто может её решить',
    hospTitle: 'Для больниц',
    hospDesc: 'Hospital SaaS $10,000 в месяц: квалифицированные международные направления, отслеживание конверсии, аналитика коек и очередей, интеграция EMR.',
    hospPill: 'Hospital SaaS',
    hospH1: 'B2B-дверь, которая не прячется за микрофоном.',
    hospLede: 'Квалифицированные международные направления, отслеживание конверсии, аналитика коек и очередей, интеграция EMR. Это то, что уходит наружу. Партнёрам не нужно прокручивать голосовое демо, чтобы увидеть бизнес.',
    hospMarketplace: 'Смотреть рынок помощи',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS $10,000 в месяц.',
    hospSkuSub: 'В эфире. Не лист ожидания. Тот же платёжный путь, что и у остального ByOnco.',
    hospRefH: 'Международные направления',
    hospRefP: 'Квалифицированные входящие случаи с пакетами документов, не сайт-брошюра и надежда.',
    hospBedsH: 'Койки, очереди, конверсия',
    hospBedsP: 'Какие направления конвертируются, где застревают, и что ещё нужно координатору.',
    hospEmrH: 'Интеграция EMR',
    hospEmrP: 'Онбординг с менеджером аккаунта. Выделенная поддержка. Лесная зелёная дверь остаётся первоклассной в навигации и подвале.',
    hospPartners: 'Поговорить с партнёрствами',
  },
  it: {
    openTheApp: 'Inizia gratis',
    langStatWrite: 'lingue in cui scrivere',
    langStatSpeak: 'lingue in cui parlare',
    product: 'Prodotto',
    company: 'Azienda',
    coverage: 'Copertura',
    pricing: 'Prezzi',
    contact: 'Contatti',
    privacy: 'Privacy',
    terms: 'Termini',
    security: 'Sicurezza',
    trainedOncologists: 'addestrata da oncologi',
    footerBlurb: 'Una compagna di oncologia per pazienti e famiglie, nella lingua in cui pensi.',
    footerDisclaimer: 'Vani fornisce informazioni generali su cancro e cura. Non diagnostica, non prescrive e non sostituisce il tuo oncologo.',
    footerEmergency: 'Negli USA in emergenza chiama il 911; per una crisi chiama o scrivi al 988.',
    speakInLangs: 'Parla in una qualsiasi delle {n} lingue.',
    cancerTypesCovered: 'tipi di cancro coperti',
    hospitalsMapped: 'ospedali mappati',
    secondOpinions: 'seconde opinioni esperte',
    problemEyebrow: 'Il problema',
    howEyebrow: 'Come funziona',
    howSub: 'Niente moduli, niente menu. La scrittura funziona già in {n} lingue.',
    howAskH: 'Chiedi con le tue parole',
    howAskP: 'Scrivi come parli, in una qualsiasi delle {n} lingue. Lascia chemotherapy e platelets in inglese. L’inglese è l’impostazione predefinita per le cure negli Stati Uniti.',
    howAnswerH: 'Una risposta breve e umana',
    howRememberH: 'Lei ricorda',
    langEyebrow: 'Lingue',
    scopeEyebrow: 'Copertura',
    scopeH2: 'Tipi di cancro, e tutta la vita intorno.',
    scopeH2n: '{n} tipi di cancro, e tutta la vita intorno.',
    cardTreatH: 'Trattamento e trapianto',
    cardWarnH: 'Quello di cui nessuno avverte',
    cardMoneyH: 'Soldi e logistica',
    cardRareH: 'Tumori rari, senza alzare le spalle',
    cardCareH: 'Per chi sta accanto',
    cardRefuseH: 'Ciò che rifiuta',
    safetyEyebrow: 'Sicurezza',
    safetyH2: 'Fatta da persone che danno per scontato che verrà usata alle 3 di notte, da qualcuno spaventato.',
    safetyRedK: 'Bandiere rosse',
    safetyInventK: 'Niente invenzioni',
    safetyBoundK: 'Confini',
    safetyDistressK: 'Distress',
    safetyPrivK: 'Privacy',
    priceEyebrow: 'Prezzi',
    priceSub: 'Piani a partire da $14.99 al mese, da $39.99. Disdici quando vuoi.',
    planFree: 'Gratis',
    planFreeWho: 'Provalo prima',
    planFree1: '2 domande, senza carta',
    planFree2: 'Tutte le {n} lingue',
    planProWho: 'Pazienti e famiglie',
    planProTag: 'La maggior parte delle famiglie sceglie questo',
    planPro1: 'Domande illimitate in {n} lingue',
    startPro: 'Inizia PRO',
    planLife: 'A vita',
    getLifetime: 'Prendi a vita',
    saasLead: 'Centri oncologici:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'per referral internazionali, analitica di letti e code, tracciamento della conversione e integrazione EMR.',
    requestDemo: 'Richiedi una demo',
    faqEyebrow: 'Domande',
    faqH2: 'Quello che ci chiedono per primi.',
    faq1q: 'Sostituisce un oncologo?',
    faq4q: 'Funziona solo in inglese?',
    faq4a: 'Scrivi in {n} lingue. L’inglese è l’impostazione predefinita per gli Stati Uniti.',
    faq5q: 'Per chi è?',
    closeH2: 'Nessuno dovrebbe affrontare questo tra giovedì e il prossimo messaggio del portale.',
    servicesH2: 'Cura oncologica completa, oltre la conversazione',
    servicesLead: 'ByOnco ti collega a ospedali USA, tabelle di costo in USD, percorsi per tumori rari, seconde opinioni e pacchetti di cura.',
    howByonco: 'Come funziona ByOnco',
    howByoncoH2: 'Come funziona ByOnco',
    specializedCare: 'Cura specialistica',
    rareUltraH2: 'Competenza su tumori rari e ultra-rari',
    rareSpecialize: 'Siamo specializzati in {n} tipi di tumore raro',
    rareMapped: ', mappati in {n} centri.',
    viewRare: 'Vedi tutti i tumori rari',
    fullMarketplace: 'Mercato di cura completo',
    teamEyebrow: 'Costruito da un team di prim’ordine',
    teamTag: 'Costruito da chi capisce il dolore, portato da chi può risolverlo',
    hospTitle: 'Per gli ospedali',
    hospDesc: 'Hospital SaaS a $10,000 al mese: referral internazionali qualificati, tracciamento della conversione, analitica di letti e code, integrazione EMR.',
    hospPill: 'Hospital SaaS',
    hospH1: 'Una porta B2B che non si nasconde dietro un microfono.',
    hospLede: 'Referral internazionali qualificati, tracciamento della conversione, analitica di letti e code, e integrazione EMR. Questo è ciò che l’outbound invia. I partner non devono scorrere oltre una demo vocale per vedere un’azienda.',
    hospMarketplace: 'Vedi il mercato di cura',
    hospSkuEyebrow: 'Lo SKU',
    hospSkuH2: 'Hospital SaaS a $10,000 al mese.',
    hospSkuSub: 'Live. Non una lista d’attesa. Lo stesso percorso di pagamento del resto di ByOnco.',
    hospRefH: 'Referral internazionali',
    hospRefP: 'Casi in ingresso qualificati con pacchetti di documenti, non un sito brochure e una speranza.',
    hospBedsH: 'Letti, code, conversione',
    hospBedsP: 'Vedi quali referral convertono, dove si bloccano e cosa manca ancora al coordinatore.',
    hospEmrH: 'Integrazione EMR',
    hospEmrP: 'Onboarding gestito per account. Supporto dedicato. La porta verde bosco resta di prima classe in navigazione e footer.',
    hospPartners: 'Parla con le partnership',
  },
  nl: {
    openTheApp: 'Gratis starten',
    langStatWrite: 'talen om in te schrijven',
    langStatSpeak: 'talen om in te spreken',
    product: 'Product',
    company: 'Bedrijf',
    coverage: 'Dekking',
    pricing: 'Prijzen',
    contact: 'Contact',
    privacy: 'Privacy',
    terms: 'Voorwaarden',
    security: 'Beveiliging',
    trainedOncologists: 'getraind door oncologen',
    footerBlurb: 'Een oncologische metgezel voor patiënten en families, in de taal waarin je denkt.',
    footerDisclaimer: 'Vani geeft algemene informatie over kanker en zorg. Ze diagnosticeert niet, schrijft niet voor en vervangt je oncoloog niet.',
    footerEmergency: 'In de VS bel 911 bij nood; bij een crisis bel of sms 988.',
    speakInLangs: 'Spreek in een van de {n} talen.',
    cancerTypesCovered: 'bedekte kankersoorten',
    hospitalsMapped: 'in kaart gebrachte ziekenhuizen',
    secondOpinions: 'deskundige second opinions',
    problemEyebrow: 'Het probleem',
    howEyebrow: 'Hoe het werkt',
    howSub: 'Geen formulieren, geen menu’s. Schrijven werkt al in {n} talen.',
    howAskH: 'Vraag in je eigen woorden',
    howAskP: 'Schrijf zoals je spreekt, in een van de {n} talen. Laat chemotherapy en platelets in het Engels. Engels is de standaard voor zorg in de VS.',
    howAnswerH: 'Een kort, menselijk antwoord',
    howRememberH: 'Zij onthoudt',
    langEyebrow: 'Talen',
    scopeEyebrow: 'Dekking',
    scopeH2: 'Kankersoorten, en het hele leven eromheen.',
    scopeH2n: '{n} kankersoorten, en het hele leven eromheen.',
    cardTreatH: 'Behandeling en transplantatie',
    cardWarnH: 'Waar niemand voor waarschuwt',
    cardMoneyH: 'Geld en logistiek',
    cardRareH: 'Zeldzame kankers, zonder schouderophalen',
    cardCareH: 'Voor de persoon ernaast',
    cardRefuseH: 'Wat zij weigert',
    safetyEyebrow: 'Veiligheid',
    safetyH2: 'Gebouwd door mensen die aannemen dat het om 3 uur ’s nachts gebruikt wordt, door iemand die bang is.',
    safetyRedK: 'Rode vlaggen',
    safetyInventK: 'Geen verzinsels',
    safetyBoundK: 'Grenzen',
    safetyDistressK: 'Distress',
    safetyPrivK: 'Privacy',
    priceEyebrow: 'Prijzen',
    priceSub: 'Abonnementen vanaf $14.99 per maand, van $39.99. Altijd opzegbaar.',
    planFree: 'Gratis',
    planFreeWho: 'Eerst proberen',
    planFree1: '2 vragen, geen kaart',
    planFree2: 'Alle {n} talen',
    planProWho: 'Patiënten en families',
    planProTag: 'De meeste families kiezen dit',
    planPro1: 'Onbeperkte vragen in {n} talen',
    startPro: 'Start PRO',
    planLife: 'Levenslang',
    getLifetime: 'Neem levenslang',
    saasLead: 'Kankercentra:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'voor internationale verwijzingen, bed- en wachtrijanalyse, conversietracking en EMR-integratie.',
    requestDemo: 'Vraag een demo',
    faqEyebrow: 'Vragen',
    faqH2: 'Wat mensen ons eerst vragen.',
    faq1q: 'Is dit een vervanging voor een oncoloog?',
    faq4q: 'Werkt dit alleen in het Engels?',
    faq4a: 'Schrijf in {n} talen. Engels is de standaard voor de VS.',
    faq5q: 'Voor wie is dit?',
    closeH2: 'Niemand zou dit alleen moeten doorstaan tussen donderdag en het volgende portaalbericht.',
    servicesH2: 'Volledige kankerzorg, voorbij het gesprek',
    servicesLead: 'ByOnco koppelt je aan Amerikaanse ziekenhuizen, USD-kostentabellen, zeldzame-kankerpaden, second opinions en zorgpakketten.',
    howByonco: 'Hoe ByOnco werkt',
    howByoncoH2: 'Hoe ByOnco werkt',
    specializedCare: 'Gespecialiseerde zorg',
    rareUltraH2: 'Expertise in zeldzame en ultra-zeldzame kankers',
    rareSpecialize: 'We specialiseren ons in {n} zeldzame kankersoorten',
    rareMapped: ', in kaart gebracht over {n} centra.',
    viewRare: 'Alle zeldzame kankers bekijken',
    fullMarketplace: 'Volledige zorgmarktplaats',
    teamEyebrow: 'Gebouwd door een team van wereldklasse',
    teamTag: 'Gebouwd door mensen die de pijn kennen, aangedreven door mensen die hem kunnen oplossen',
    hospTitle: 'Voor ziekenhuizen',
    hospDesc: 'Hospital SaaS voor $10,000 per maand: gekwalificeerde internationale verwijzingen, conversietracking, bed- en wachtrijanalyse, en EMR-integratie.',
    hospPill: 'Hospital SaaS',
    hospH1: 'Een B2B-deur die zich niet achter een microfoon verstopt.',
    hospLede: 'Gekwalificeerde internationale verwijzingen, conversietracking, bed- en wachtrijanalyse, en EMR-integratie. Dit stuurt outbound. Partners hoeven niet langs een voice-demo te scrollen om een bedrijf te zien.',
    hospMarketplace: 'Bekijk de zorgmarktplaats',
    hospSkuEyebrow: 'De SKU',
    hospSkuH2: 'Hospital SaaS voor $10,000 per maand.',
    hospSkuSub: 'Live. Geen wachtlijst. Hetzelfde betaalpad als de rest van ByOnco.',
    hospRefH: 'Internationale verwijzingen',
    hospRefP: 'Gekwalificeerde inbound-casussen met documentatiepakketten, geen brochuresite en een hoop.',
    hospBedsH: 'Bedden, wachtrijen, conversie',
    hospBedsP: 'Zie welke verwijzingen converteren, waar ze vastlopen, en wat de coördinator nog nodig heeft.',
    hospEmrH: 'EMR-integratie',
    hospEmrP: 'Accountbeheerde onboarding. Toegewijde support. De bosgroene deur blijft eersteklas in navigatie en footer.',
    hospPartners: 'Praat met partnerships',
  },
  mr: {
    openTheApp: 'मोफत सुरू करा',
    langStatWrite: 'लिहिता येणाऱ्या भाषा',
    langStatSpeak: 'बोलता येणाऱ्या भाषा',
    product: 'उत्पादन',
    company: 'कंपनी',
    coverage: 'कव्हरेज',
    pricing: 'किंमत',
    contact: 'संपर्क',
    privacy: 'गोपनीयता',
    terms: 'नियम',
    security: 'सुरक्षा',
    trainedOncologists: 'ऑन्कोलॉजिस्टांनी प्रशिक्षित',
    footerBlurb: 'रुग्ण आणि कुटुंबांसाठी ऑन्कोलॉजी साथी, ज्या भाषेत तुम्ही विचार करता त्यात.',
    footerDisclaimer: 'Vani कर्करोग आणि काळजीची सामान्य माहिती देते. निदान करत नाही, औषध लिहित नाही, आणि तुमच्या ऑन्कोलॉजिस्टची जागा घेत नाही.',
    footerEmergency: 'अमेरिकेत इमर्जन्सीवर 911; संकटासाठी 988 वर कॉल किंवा टेक्स्ट करा.',
    speakInLangs: '{n} भाषांत बोला.',
    heroLede: 'कर्करोगाच्या रुग्णांसाठी आणि त्यांना सांभाळणाऱ्या कुटुंबांसाठी साथी. उपचार, जेवण, साइड इफेक्ट, इंश्योरन्स, किंवा आठवडा कसा काढायचा, ज्या भाषेत तुम्ही खरंच विचार करता त्यात विचारा.',
    cancerTypesCovered: 'कव्हर केलेले कर्करोग प्रकार',
    hospitalsMapped: 'मॅप केलेली रुग्णालये',
    secondOpinions: 'तज्ज्ञ दुसरे मत',
    problemEyebrow: 'समस्या',
    problemH2: 'प्रश्न क्लिनिकच्या वेळेत येत नाहीत.',
    howEyebrow: 'कसं चालतं',
    howSub: 'फॉर्म नाहीत, मेनू नाहीत. लिहिणं आधीच {n} भाषांत चालतं.',
    howAskH: 'स्वतःच्या शब्दांत विचारा',
    howAskP: 'जसं बोलता तसं लिहा, {n} भाषांत. chemotherapy आणि platelets इंग्रजीत ठेवा. अमेरिकन काळजीसाठी इंग्रजी डिफॉल्ट आहे.',
    howAnswerH: 'छोटं, माणसासारखं उत्तर',
    howRememberH: 'ती आठवते',
    langEyebrow: 'भाषा',
    scopeEyebrow: 'कव्हरेज',
    scopeH2: 'कर्करोगाचे प्रकार, आणि त्याभोवतीचं संपूर्ण आयुष्य.',
    scopeH2n: '{n} कर्करोग प्रकार, आणि त्याभोवतीचं संपूर्ण आयुष्य.',
    cardTreatH: 'उपचार आणि ट्रान्सप्लांट',
    cardWarnH: 'ज्याची कोणी पूर्वसूचना देत नाही',
    cardMoneyH: 'पैसा आणि लॉजिस्टिक्स',
    cardRareH: 'दुर्मिळ कर्करोग, खांदे उचलल्याशिवाय',
    cardCareH: 'शेजारी असलेल्यासाठी',
    cardRefuseH: 'ती काय नाकारते',
    safetyEyebrow: 'सुरक्षा',
    safetyH2: 'अशा लोकांनी बनवले जे मानतात की रात्री 3 वाजता भीती वाटणारा कोणी वापरेल.',
    safetyRedK: 'रेड फ्लॅग',
    safetyInventK: 'कुठली कल्पना नाही',
    safetyBoundK: 'मर्यादा',
    safetyDistressK: 'संकट',
    safetyPrivK: 'गोपनीयता',
    priceEyebrow: 'किंमत',
    priceSub: 'प्लॅन्स $14.99 प्रति महिना पासून सुरू, $39.99 वरून कमी. कधीही रद्द करा.',
    planFree: 'मोफत',
    planFreeWho: 'आधी वापरून पहा',
    planFree1: '2 प्रश्न, कार्ड नाही',
    planFree2: 'सर्व {n} भाषा',
    planProWho: 'रुग्ण आणि कुटुंब',
    planProTag: 'बहुतेक कुटुंब हे निवडतात',
    planPro1: '{n} भाषांत अमर्याद प्रश्न',
    startPro: 'PRO सुरू करा',
    planLife: 'आयुष्यभर',
    getLifetime: 'आयुष्यभर घ्या',
    saasLead: 'कर्करोग केंद्र:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'आंतरराष्ट्रीय रेफरल, बेड आणि रांग विश्लेषण, कन्व्हर्जन ट्रॅकिंग, EMR एकत्रीकरण.',
    requestDemo: 'डेमो मागा',
    faqEyebrow: 'प्रश्न',
    faqH2: 'लोक आधी काय विचारतात.',
    faq1q: 'हे ऑन्कोलॉजिस्टची जागा घेतं का?',
    faq4q: 'हे फक्त इंग्रजीत चालतं का?',
    faq4a: '{n} भाषांत लिहून विचारा. अमेरिकेसाठी इंग्रजी डिफॉल्ट आहे.',
    faq5q: 'हे कोणासाठी आहे?',
    closeH2: 'गुरुवार आणि पुढच्या पोर्टल मेसेजच्या मध्ये कोणाला एकटं पडू नये.',
    servicesH2: 'पूर्ण कर्करोग काळजी, संभाषणापलीकडे',
    servicesLead: 'ByOnco तुम्हाला अमेरिकन रुग्णालये, USD खर्च तक्त्या, दुर्मिळ कर्करोग मार्ग, दुसरी मते आणि केअर पॅकेजशी जोडतो.',
    howByonco: 'ByOnco कसं चालतं',
    howByoncoH2: 'ByOnco कसं चालतं',
    specializedCare: 'विशेष काळजी',
    rareUltraH2: 'दुर्मिळ आणि अतिदुर्मिळ कर्करोग तज्ज्ञता',
    rareSpecialize: 'आम्ही {n} दुर्मिळ कर्करोग प्रकारांत तज्ज्ञ आहोत',
    rareMapped: ', {n} केंद्रांमध्ये मॅप केलेले.',
    viewRare: 'सर्व दुर्मिळ कर्करोग पहा',
    fullMarketplace: 'पूर्ण केअर मार्केटप्लेस',
    teamEyebrow: 'जागतिक दर्जाच्या टीमने बनवले',
    teamTag: 'वेदना समजणाऱ्यांनी बनवले, सोडवू शकणाऱ्यांनी चालवले',
    hospTitle: 'रुग्णालयांसाठी',
    hospDesc: 'Hospital SaaS महिन्याला $10,000: पात्र आंतरराष्ट्रीय रेफरल, कन्व्हर्जन ट्रॅकिंग, बेड आणि रांग विश्लेषण, EMR एकत्रीकरण.',
    hospPill: 'Hospital SaaS',
    hospH1: 'मायक्रोफोनमागे न लपणारा B2B दरवाजा.',
    hospLede: 'पात्र आंतरराष्ट्रीय रेफरल, कन्व्हर्जन ट्रॅकिंग, बेड आणि रांग विश्लेषण, आणि EMR एकत्रीकरण. आउटबाउंड हेच पाठवतं. पार्टनरना व्यवसाय पाहण्यासाठी व्हॉइस डेमो ओलांडण्याची गरज नाही.',
    hospMarketplace: 'केअर मार्केटप्लेस पहा',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS महिन्याला $10,000.',
    hospSkuSub: 'लाइव्ह. वेटलिस्ट नाही. बाकी ByOncoसारखाच पेमेंट मार्ग.',
    hospRefH: 'आंतरराष्ट्रीय रेफरल',
    hospRefP: 'कागदपत्र पॅकेट असलेले पात्र इनबाउंड केस, ब्रोशर साइट आणि आशा नाही.',
    hospBedsH: 'बेड, रांगा, कन्व्हर्जन',
    hospBedsP: 'कोणते रेफरल कन्व्हर्ट होतात, कुठे अडकतात, आणि कोऑर्डिनेटरला अजून काय हवं.',
    hospEmrH: 'EMR एकत्रीकरण',
    hospEmrP: 'अकाउंट-मॅनेज्ड ऑनबोर्डिंग. समर्पित सपोर्ट. वन-हिरवा दरवाजा नेव्ह आणि फूटरमध्ये प्रथम श्रेणी राहतो.',
    hospPartners: 'पार्टनरशिपशी बोला',
  },
  ta: {
    openTheApp: 'இலவசமாகத் தொடங்குங்கள்',
    langStatWrite: 'எழுதக்கூடிய மொழிகள்',
    langStatSpeak: 'பேசக்கூடிய மொழிகள்',
    product: 'தயாரிப்பு',
    company: 'நிறுவனம்',
    coverage: 'பாதுகாப்பு',
    pricing: 'விலை',
    contact: 'தொடர்பு',
    privacy: 'தனியுரிமை',
    terms: 'விதிமுறைகள்',
    security: 'பாதுகாப்பு',
    trainedOncologists: 'புற்றுநோய் மருத்துவர்களால் பயிற்சி',
    footerBlurb: 'நோயாளிகள் மற்றும் குடும்பங்களுக்கான புற்றுநோய் துணை, நீங்கள் நினைக்கும் மொழியில்.',
    footerDisclaimer: 'Vani புற்றுநோய் மற்றும் பராமரிப்பு பற்றிய பொது தகவல் தருகிறாள். நோயறிதல் செய்வதில்லை, மருந்து எழுதுவதில்லை, உங்கள் புற்றுநோய் மருத்துவரை மாற்றுவதில்லை.',
    footerEmergency: 'அமெரிக்க அவசரத்தில் 911; நெருக்கடிக்கு 988 அழைக்கவும் அல்லது உரை அனுப்பவும்.',
    speakInLangs: '{n} மொழிகளில் பேசுங்கள்.',
    heroLede: 'புற்றுநோய் நோயாளிகள் மற்றும் அவர்களை தாங்கும் குடும்பங்களுக்கான துணை. சிகிச்சை, உணவு, பக்க விளைவுகள், காப்பீடு, அல்லது வாரத்தை கடப்பது, நீங்கள் உண்மையில் நினைக்கும் மொழியில் கேளுங்கள்.',
    cancerTypesCovered: 'மூடப்பட்ட புற்றுநோய் வகைகள்',
    hospitalsMapped: 'வரைபடமாக்கப்பட்ட மருத்துவமனைகள்',
    secondOpinions: 'நிபுணர் இரண்டாம் கருத்து',
    problemEyebrow: 'பிரச்சினை',
    howEyebrow: 'எப்படி வேலை செய்கிறது',
    howSub: 'படிவங்கள் இல்லை, மெனுக்கள் இல்லை. எழுத்து ஏற்கனவே {n} மொழிகளில் வேலை செய்கிறது.',
    howAskH: 'உங்கள் சொற்களில் கேளுங்கள்',
    howAskP: 'பேசுவது போல் எழுதுங்கள், {n} மொழிகளில். chemotherapy மற்றும் platelets ஆங்கிலத்தில் வையுங்கள். அமெரிக்க பராமரிப்புக்கு ஆங்கிலம் இயல்புநிலை.',
    howAnswerH: 'குறுகிய, மனித பதில்',
    howRememberH: 'அவள் நினைவில் வைக்கிறாள்',
    langEyebrow: 'மொழிகள்',
    scopeEyebrow: 'பாதுகாப்பு',
    scopeH2: 'புற்றுநோய் வகைகள், மற்றும் அதைச் சுற்றிய வாழ்க்கை.',
    scopeH2n: '{n} புற்றுநோய் வகைகள், மற்றும் அதைச் சுற்றிய வாழ்க்கை.',
    cardTreatH: 'சிகிச்சை மற்றும் மாற்று',
    cardWarnH: 'யாரும் முன் எச்சரிக்காதவை',
    cardMoneyH: 'பணம் மற்றும் தளவாடம்',
    cardRareH: 'அரிய புற்றுநோய்கள், தோள் குலுக்காமல்',
    cardCareH: 'அருகில் இருப்பவருக்காக',
    cardRefuseH: 'அவள் மறுப்பவை',
    safetyEyebrow: 'பாதுகாப்பு',
    safetyH2: 'இரவு 3 மணிக்கு பயந்த ஒருவர் பயன்படுத்துவார் என்று கருதி உருவாக்கியவர்கள்.',
    safetyRedK: 'சிவப்பு கொடிகள்',
    safetyInventK: 'கற்பனை இல்லை',
    safetyBoundK: 'எல்லைகள்',
    safetyDistressK: 'நெருக்கடி',
    safetyPrivK: 'தனியுரிமை',
    priceEyebrow: 'விலை',
    priceSub: 'திட்டங்கள் மாதம் $14.99 முதல் தொடங்குகின்றன, $39.99 இலிருந்து குறைவு.',
    planFree: 'இலவசம்',
    planFreeWho: 'முதலில் முயற்சிக்க',
    planFree1: '2 கேள்விகள், அட்டை இல்லை',
    planFree2: 'அனைத்து {n} மொழிகளும்',
    planProWho: 'நோயாளிகள் மற்றும் குடும்பங்கள்',
    planProTag: 'பெரும்பாலான குடும்பங்கள் இதை தேர்வு செய்கின்றன',
    planPro1: '{n} மொழிகளில் வரம்பற்ற கேள்விகள்',
    startPro: 'PRO தொடங்கு',
    planLife: 'வாழ்நாள்',
    getLifetime: 'வாழ்நாள் பெறுக',
    saasLead: 'புற்றுநோய் மையங்கள்:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'சர்வதேச பரிந்துரைகள், படுக்கை மற்றும் வரிசை பகுப்பாய்வு, மாற்று கண்காணிப்பு, EMR ஒருங்கிணைப்பு.',
    requestDemo: 'டெமோ கேளுங்கள்',
    faqEyebrow: 'கேள்விகள்',
    faqH2: 'முதலில் கேட்பவை.',
    faq1q: 'இது புற்றுநோய் மருத்துவரை மாற்றுகிறதா?',
    faq4q: 'ஆங்கிலத்தில் மட்டும்தானா?',
    faq4a: '{n} மொழிகளில் எழுதிக் கேளுங்கள். அமெரிக்காவுக்கு ஆங்கிலம் இயல்புநிலை.',
    faq5q: 'இது யாருக்காக?',
    closeH2: 'வியாழன் மற்றும் அடுத்த போர்டல் செய்திக்கு இடையே யாரும் தனியாக இருக்கக்கூடாது.',
    servicesH2: 'முழு புற்றுநோய் பராமரிப்பு, உரையாடலுக்கு அப்பால்',
    servicesLead: 'ByOnco உங்களை அமெரிக்க மருத்துவமனைகள், USD செலவு அட்டவணைகள், அரிய புற்றுநோய் பாதைகள், இரண்டாம் கருத்துகள் மற்றும் பராமரிப்பு தொகுப்புகளுடன் இணைக்கிறது.',
    howByonco: 'ByOnco எப்படி வேலை செய்கிறது',
    howByoncoH2: 'ByOnco எப்படி வேலை செய்கிறது',
    specializedCare: 'சிறப்பு பராமரிப்பு',
    rareUltraH2: 'அரிய மற்றும் மிக அரிய புற்றுநோய் நிபுணத்துவம்',
    rareSpecialize: 'நாங்கள் {n} அரிய புற்றுநோய் வகைகளில் நிபுணத்துவம் பெற்றுள்ளோம்',
    rareMapped: ', {n} மையங்களில் வரைபடமாக்கப்பட்டவை.',
    viewRare: 'அனைத்து அரிய புற்றுநோய்களையும் காண்க',
    fullMarketplace: 'முழு பராமரிப்பு சந்தை',
    teamEyebrow: 'உலகத்தரம் வாய்ந்த குழு உருவாக்கியது',
    teamTag: 'வலியை புரிந்துகொள்பவர்கள் உருவாக்கி, தீர்க்கக்கூடியவர்கள் இயக்குகிறார்கள்',
    hospTitle: 'மருத்துவமனைகளுக்கு',
    hospDesc: 'Hospital SaaS மாதம் $10,000: தகுதிவாய்ந்த சர்வதேச பரிந்துரைகள், மாற்று கண்காணிப்பு, படுக்கை மற்றும் வரிசை பகுப்பாய்வு, EMR ஒருங்கிணைப்பு.',
    hospPill: 'Hospital SaaS',
    hospH1: 'மைக்ரோஃபோனுக்குப் பின்னால் மறையாத B2B கதவு.',
    hospLede: 'தகுதிவாய்ந்த சர்வதேச பரிந்துரைகள், மாற்று கண்காணிப்பு, படுக்கை மற்றும் வரிசை பகுப்பாய்வு, மற்றும் EMR ஒருங்கிணைப்பு. வெளியே அனுப்புவது இதுவே. கூட்டாளிகள் வணிகத்தை காண குரல் டெமோவை கடக்க வேண்டியதில்லை.',
    hospMarketplace: 'பராமரிப்பு சந்தையை காண்க',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS மாதம் $10,000.',
    hospSkuSub: 'நேரலை. காத்திருப்பு பட்டியல் அல்ல. மற்ற ByOnco போன்ற அதே பணம் பாதை.',
    hospRefH: 'சர்வதேச பரிந்துரைகள்',
    hospRefP: 'ஆவண தொகுப்புகளுடன் தகுதிவாய்ந்த உள்ளே வரும் வழக்குகள், சிற்றேடு தளம் மற்றும் நம்பிக்கை அல்ல.',
    hospBedsH: 'படுக்கைகள், வரிசைகள், மாற்றம்',
    hospBedsP: 'எந்த பரிந்துரைகள் மாறுகின்றன, எங்கே நிறுத்துகின்றன, ஒருங்கிணைப்பாளருக்கு இன்னும் என்ன வேண்டும்.',
    hospEmrH: 'EMR ஒருங்கிணைப்பு',
    hospEmrP: 'கணக்கு நிர்வகிக்கப்பட்ட அறிமுகம். அர்ப்பணிப்பு ஆதரவு. காட்டு பச்சை கதவு வழிசெலுத்தல் மற்றும் அடியில் முதல் வகுப்பாக இருக்கும்.',
    hospPartners: 'கூட்டாண்மையுடன் பேசுங்கள்',
  },
  te: {
    openTheApp: 'ఉచితంగా ప్రారంభించండి',
    langStatWrite: 'రాయగల భాషలు',
    langStatSpeak: 'మాట్లాడగల భాషలు',
    product: 'ఉత్పత్తి',
    company: 'కంపెనీ',
    coverage: 'కవరేజ్',
    pricing: 'ధర',
    contact: 'సంప్రదించండి',
    privacy: 'గోప్యత',
    terms: 'నిబంధనలు',
    security: 'భద్రత',
    seeHow: 'ఎలా పనిచేస్తుందో చూడండి',
    talkTeam: 'టీమ్‌తో మాట్లాడండి',
    trainedOncologists: 'ఆంకాలజిస్టుల శిక్షణ',
    footerBlurb: 'రోగులు మరియు కుటుంబాల కోసం ఆంకాలజీ సహచరి, మీరు ఆలోచించే భాషలో.',
    footerDisclaimer: 'Vani క్యాన్సర్ మరియు సంరక్షణ గురించి సాధారణ సమాచారం ఇస్తుంది. నిర్ధారణ చేయదు, మందు రాయదు, మీ ఆంకాలజిస్టును భర్తీ చేయదు.',
    footerEmergency: 'అమెరికాలో అత్యవసరానికి 911; సంక్షోభానికి 988కు కాల్ లేదా టెక్స్ట్ చేయండి.',
    speakInLangs: '{n} భాషల్లో మాట్లాడండి.',
    heroLede: 'క్యాన్సర్ రోగులు మరియు వారిని మోసే కుటుంబాల కోసం సహచరి. చికిత్స, ఆహారం, దుష్ప్రభావాలు, బీమా, లేదా వారం ఎలా గడపాలో, మీరు నిజంగా ఆలోచించే భాషలో అడగండి.',
    cancerTypesCovered: 'కవర్ చేసిన క్యాన్సర్ రకాలు',
    hospitalsMapped: 'మ్యాప్ చేసిన ఆసుపత్రులు',
    secondOpinions: 'నిపుణుల రెండవ అభిప్రాయం',
    problemEyebrow: 'సమస్య',
    howEyebrow: 'ఎలా పనిచేస్తుంది',
    howSub: 'ఫారమ్‌లు లేవు, మెనూలు లేవు. రాయడం ఇప్పటికే {n} భాషల్లో పనిచేస్తుంది.',
    howAskH: 'మీ మాటల్లో అడగండి',
    howAskP: 'మాట్లాడినట్టు రాయండి, {n} భాషల్లో. chemotherapy మరియు platelets ఇంగ్లిష్‌లో ఉంచండి. అమెరికన్ సంరక్షణకు ఇంగ్లిష్ డిఫాల్ట్.',
    howAnswerH: 'చిన్న, మనిషిలా సమాధానం',
    howRememberH: 'ఆమె గుర్తుంచుకుంటుంది',
    langEyebrow: 'భాషలు',
    scopeEyebrow: 'కవరేజ్',
    scopeH2: 'క్యాన్సర్ రకాలు, మరియు చుట్టూ ఉన్న జీవితం.',
    scopeH2n: '{n} క్యాన్సర్ రకాలు, మరియు చుట్టూ ఉన్న జీవితం.',
    cardTreatH: 'చికిత్స మరియు ట్రాన్స్‌ప్లాంట్',
    cardWarnH: 'ఎవరూ ముందుగా చెప్పనివి',
    cardMoneyH: 'డబ్బు మరియు లాజిస్టిక్స్',
    cardRareH: 'అరుదైన క్యాన్సర్లు, భుజాలు ఎత్తకుండా',
    cardCareH: 'పక్కన ఉన్న వ్యక్తి కోసం',
    cardRefuseH: 'ఆమె తిరస్కరించేది',
    safetyEyebrow: 'భద్రత',
    safetyH2: 'రాత్రి 3 గంటలకు భయపడిన వాడు వాడతాడని భావించి తయారు చేసినవారు.',
    safetyRedK: 'రెడ్ ఫ్లాగ్స్',
    safetyInventK: 'కల్పన లేదు',
    safetyBoundK: 'సరిహద్దులు',
    safetyDistressK: 'సంక్షోభం',
    safetyPrivK: 'గోప్యత',
    priceEyebrow: 'ధర',
    priceSub: 'ప్లాన్‌లు నెలకు $14.99 నుండి ప్రారంభం, $39.99 నుంచి తగ్గింపు.',
    planFree: 'ఉచితం',
    planFreeWho: 'ముందు ప్రయత్నించండి',
    planFree1: '2 ప్రశ్నలు, కార్డు లేదు',
    planFree2: 'అన్ని {n} భాషలు',
    planProWho: 'రోగులు మరియు కుటుంబాలు',
    planProTag: 'చాలా కుటుంబాలు దీన్ని ఎంచుకుంటాయి',
    planPro1: '{n} భాషల్లో అపరిమిత ప్రశ్నలు',
    startPro: 'PRO ప్రారంభించండి',
    planLife: 'జీవితకాలం',
    getLifetime: 'జీవితకాలం తీసుకోండి',
    saasLead: 'క్యాన్సర్ కేంద్రాలు:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'అంతర్జాతీయ రెఫరల్స్, బెడ్ మరియు క్యూ అనలిటిక్స్, కన్వర్షన్ ట్రాకింగ్, EMR ఇంటిగ్రేషన్.',
    requestDemo: 'డెమో అడగండి',
    faqEyebrow: 'ప్రశ్నలు',
    faqH2: 'ముందుగా అడిగేవి.',
    faq1q: 'ఇది ఆంకాలజిస్టును భర్తీ చేస్తుందా?',
    faq4q: 'ఇంగ్లిష్‌లో మాత్రమేనా?',
    faq4a: '{n} భాషల్లో రాసి అడగండి. అమెరికాకు ఇంగ్లిష్ డిఫాల్ట్.',
    faq5q: 'ఇది ఎవరికోసం?',
    closeH2: 'గురువారం మరియు తర్వాతి పోర్టల్ సందేశం మధ్య ఎవరూ ఒంటరిగా ఉండకూడదు.',
    servicesH2: 'పూర్తి క్యాన్సర్ సంరక్షణ, సంభాషణకు మించి',
    servicesLead: 'ByOnco మిమ్మల్ని అమెరికన్ ఆసుపత్రులు, USD ఖర్చు పట్టికలు, అరుదైన క్యాన్సర్ మార్గాలు, రెండవ అభిప్రాయాలు మరియు కేర్ ప్యాకేజీలకు కలుపుతుంది.',
    howByonco: 'ByOnco ఎలా పనిచేస్తుంది',
    howByoncoH2: 'ByOnco ఎలా పనిచేస్తుంది',
    specializedCare: 'ప్రత్యేక సంరక్షణ',
    rareUltraH2: 'అరుదైన మరియు అత్యంత అరుదైన క్యాన్సర్ నైపుణ్యం',
    rareSpecialize: 'మేము {n} అరుదైన క్యాన్సర్ రకాల్లో నిపుణులం',
    rareMapped: ', {n} కేంద్రాల్లో మ్యాప్ చేయబడింది.',
    viewRare: 'అన్ని అరుదైన క్యాన్సర్లు చూడండి',
    fullMarketplace: 'పూర్తి కేర్ మార్కెట్‌ప్లేస్',
    teamEyebrow: 'ప్రపంచ స్థాయి టీమ్ నిర్మించింది',
    teamTag: 'నొప్పి అర్థమయ్యే వారు నిర్మించారు, పరిష్కరించగల వారు నడుపుతారు',
    hospTitle: 'ఆసుపత్రుల కోసం',
    hospDesc: 'Hospital SaaS నెలకు $10,000: అర్హతగల అంతర్జాతీయ రెఫరల్స్, కన్వర్షన్ ట్రాకింగ్, బెడ్ మరియు క్యూ అనలిటిక్స్, EMR ఇంటిగ్రేషన్.',
    hospPill: 'Hospital SaaS',
    hospH1: 'మైక్రోఫోన్ వెనుక దాక్కోని B2B తలుపు.',
    hospLede: 'అర్హతగల అంతర్జాతీయ రెఫరల్స్, కన్వర్షన్ ట్రాకింగ్, బెడ్ మరియు క్యూ అనలిటిక్స్, మరియు EMR ఇంటిగ్రేషన్. బయటకు పంపేది ఇదే. భాగస్వాములు వ్యాపారం చూడడానికి వాయిస్ డెమోను దాటాల్సిన అవసరం లేదు.',
    hospMarketplace: 'కేర్ మార్కెట్‌ప్లేస్ చూడండి',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS నెలకు $10,000.',
    hospSkuSub: 'లైవ్. వెయిట్‌లిస్ట్ కాదు. మిగతా ByOnco లాంటి అదే చెల్లింపు మార్గం.',
    hospRefH: 'అంతర్జాతీయ రెఫరల్స్',
    hospRefP: 'డాక్యుమెంట్ ప్యాకెట్లతో అర్హతగల ఇన్‌బౌండ్ కేసులు, బ్రోచర్ సైట్ మరియు ఆశ కాదు.',
    hospBedsH: 'బెడ్స్, క్యూలు, కన్వర్షన్',
    hospBedsP: 'ఏ రెఫరల్స్ కన్వర్ట్ అవుతాయి, ఎక్కడ ఆగుతాయి, కోఆర్డినేటర్‌కు ఇంకా ఏం కావాలి.',
    hospEmrH: 'EMR ఇంటిగ్రేషన్',
    hospEmrP: 'అకౌంట్-మేనేజ్డ్ ఆన్‌బోర్డింగ్. అంకితమైన సపోర్ట్. అటవీ ఆకుపచ్చ తలుపు నావ్ మరియు ఫుటర్‌లో ఫస్ట్ క్లాస్‌గా ఉంటుంది.',
    hospPartners: 'పార్టనర్‌షిప్‌తో మాట్లాడండి',
  },
  kn: {
    openTheApp: 'ಉಚಿತವಾಗಿ ಪ್ರಾರಂಭಿಸಿ',
    langStatWrite: 'ಬರೆಯಬಹುದಾದ ಭಾಷೆಗಳು',
    langStatSpeak: 'ಮಾತನಾಡಬಹುದಾದ ಭಾಷೆಗಳು',
    product: 'ಉತ್ಪನ್ನ',
    company: 'ಕಂಪನಿ',
    coverage: 'ಕವರೇಜ್',
    pricing: 'ಬೆಲೆ',
    contact: 'ಸಂಪರ್ಕ',
    privacy: 'ಗೌಪ್ಯತೆ',
    terms: 'ನಿಯಮಗಳು',
    security: 'ಭದ್ರತೆ',
    seeHow: 'ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ ಎಂದು ನೋಡಿ',
    talkTeam: 'ತಂಡದೊಂದಿಗೆ ಮಾತನಾಡಿ',
    trainedOncologists: 'ಆಂಕಾಲಜಿಸ್ಟ್‌ಗಳ ತರಬೇತಿ',
    footerBlurb: 'ರೋಗಿಗಳು ಮತ್ತು ಕುಟುಂಬಗಳಿಗೆ ಆಂಕಾಲಜಿ ಸಂಗಾತಿ, ನೀವು ಯೋಚಿಸುವ ಭಾಷೆಯಲ್ಲಿ.',
    footerDisclaimer: 'Vani ಕ್ಯಾನ್ಸರ್ ಮತ್ತು ಆರೈಕೆಯ ಸಾಮಾನ್ಯ ಮಾಹಿತಿ ನೀಡುತ್ತಾಳೆ. ರೋಗನಿರ್ಣಯ ಮಾಡುವುದಿಲ್ಲ, ಔಷಧ ಬರೆಯುವುದಿಲ್ಲ, ನಿಮ್ಮ ಆಂಕಾಲಜಿಸ್ಟ್ ಸ್ಥಾನವನ್ನು ತೆಗೆದುಕೊಳ್ಳುವುದಿಲ್ಲ.',
    footerEmergency: 'ಅಮೆರಿಕದ ತುರ್ತಿಗೆ 911; ಬಿಕ್ಕಟ್ಟಿಗೆ 988ಗೆ ಕರೆ ಅಥವಾ ಟೆಕ್ಸ್ಟ್ ಮಾಡಿ.',
    speakInLangs: '{n} ಭಾಷೆಗಳಲ್ಲಿ ಮಾತನಾಡಿ.',
    heroLede: 'ಕ್ಯಾನ್ಸರ್ ರೋಗಿಗಳು ಮತ್ತು ಅವರನ್ನು ಹೊತ್ತ ಕುಟುಂಬಗಳಿಗೆ ಸಂಗಾತಿ. ಚಿಕಿತ್ಸೆ, ಆಹಾರ, ಪಾರ್ಶ್ವ ಪರಿಣಾಮಗಳು, ವಿಮೆ, ಅಥವಾ ವಾರವನ್ನು ಹೇಗೆ ದಾಟುವುದು, ನೀವು ನಿಜವಾಗಿ ಯೋಚಿಸುವ ಭಾಷೆಯಲ್ಲಿ ಕೇಳಿ.',
    cancerTypesCovered: 'ಆವರಿಸಿದ ಕ್ಯಾನ್ಸರ್ ಪ್ರಕಾರಗಳು',
    hospitalsMapped: 'ಮ್ಯಾಪ್ ಮಾಡಿದ ಆಸ್ಪತ್ರೆಗಳು',
    secondOpinions: 'ತಜ್ಞರ ಎರಡನೇ ಅಭಿಪ್ರಾಯ',
    problemEyebrow: 'ಸಮಸ್ಯೆ',
    howEyebrow: 'ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ',
    howSub: 'ಫಾರ್ಮ್‌ಗಳಿಲ್ಲ, ಮೆನುಗಳಿಲ್ಲ. ಬರೆಯುವುದು ಈಗಾಗಲೇ {n} ಭಾಷೆಗಳಲ್ಲಿ ಕೆಲಸ ಮಾಡುತ್ತದೆ.',
    howAskH: 'ನಿಮ್ಮ ಮಾತುಗಳಲ್ಲಿ ಕೇಳಿ',
    howAskP: 'ಮಾತನಾಡುವಂತೆ ಬರೆಯಿರಿ, {n} ಭಾಷೆಗಳಲ್ಲಿ. chemotherapy ಮತ್ತು platelets ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಇರಿಸಿ. ಅಮೆರಿಕನ್ ಆರೈಕೆಗೆ ಇಂಗ್ಲಿಷ್ ಡಿಫಾಲ್ಟ್.',
    howAnswerH: 'ಚಿಕ್ಕ, ಮಾನವ ಉತ್ತರ',
    howRememberH: 'ಅವಳು ನೆನಪಿಡುತ್ತಾಳೆ',
    langEyebrow: 'ಭಾಷೆಗಳು',
    scopeEyebrow: 'ಕವರೇಜ್',
    scopeH2: 'ಕ್ಯಾನ್ಸರ್ ಪ್ರಕಾರಗಳು, ಮತ್ತು ಸುತ್ತಲಿನ ಜೀವನ.',
    scopeH2n: '{n} ಕ್ಯಾನ್ಸರ್ ಪ್ರಕಾರಗಳು, ಮತ್ತು ಸುತ್ತಲಿನ ಜೀವನ.',
    cardTreatH: 'ಚಿಕಿತ್ಸೆ ಮತ್ತು ಟ್ರಾನ್ಸ್‌ಪ್ಲಾಂಟ್',
    cardWarnH: 'ಯಾರೂ ಮುಂಚಿತವಾಗಿ ಎಚ್ಚರಿಸದ್ದು',
    cardMoneyH: 'ಹಣ ಮತ್ತು ಲಾಜಿಸ್ಟಿಕ್ಸ್',
    cardRareH: 'ಅಪರೂಪದ ಕ್ಯಾನ್ಸರ್‌ಗಳು, ಭುಜ ಎತ್ತದೆ',
    cardCareH: 'ಪಕ್ಕದಲ್ಲಿರುವವರಿಗಾಗಿ',
    cardRefuseH: 'ಅವಳು ನಿರಾಕರಿಸುವುದು',
    safetyEyebrow: 'ಭದ್ರತೆ',
    safetyH2: 'ರಾತ್ರಿ 3ಕ್ಕೆ ಹೆದರಿದವರು ಬಳಸುತ್ತಾರೆಂದು ಭಾವಿಸಿ ನಿರ್ಮಿಸಿದವರು.',
    safetyRedK: 'ರೆಡ್ ಫ್ಲ್ಯಾಗ್‌ಗಳು',
    safetyInventK: 'ಕಲ್ಪನೆ ಇಲ್ಲ',
    safetyBoundK: 'ಗಡಿಗಳು',
    safetyDistressK: 'ಬಿಕ್ಕಟ್ಟು',
    safetyPrivK: 'ಗೌಪ್ಯತೆ',
    priceEyebrow: 'ಬೆಲೆ',
    priceSub: 'ಯೋಜನೆಗಳು ತಿಂಗಳಿಗೆ $14.99 ರಿಂದ ಪ್ರಾರಂಭ, $39.99ರಿಂದ ಕಡಿಮೆ.',
    planFree: 'ಉಚಿತ',
    planFreeWho: 'ಮೊದಲು ಪ್ರಯತ್ನಿಸಿ',
    planFree1: '2 ಪ್ರಶ್ನೆಗಳು, ಕಾರ್ಡ್ ಇಲ್ಲ',
    planFree2: 'ಎಲ್ಲ {n} ಭಾಷೆಗಳು',
    planProWho: 'ರೋಗಿಗಳು ಮತ್ತು ಕುಟುಂಬಗಳು',
    planProTag: 'ಹೆಚ್ಚಿನ ಕುಟುಂಬಗಳು ಇದನ್ನು ಆಯ್ಕೆ ಮಾಡುತ್ತವೆ',
    planPro1: '{n} ಭಾಷೆಗಳಲ್ಲಿ ಅಪರಿಮಿತ ಪ್ರಶ್ನೆಗಳು',
    startPro: 'PRO ಪ್ರಾರಂಭಿಸಿ',
    planLife: 'ಜೀವಿತಾವಧಿ',
    getLifetime: 'ಜೀವಿತಾವಧಿ ಪಡೆಯಿರಿ',
    saasLead: 'ಕ್ಯಾನ್ಸರ್ ಕೇಂದ್ರಗಳು:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'ಅಂತರರಾಷ್ಟ್ರೀಯ ರೆಫರಲ್‌ಗಳು, ಹಾಸಿಗೆ ಮತ್ತು ಸಾಲು ವಿಶ್ಲೇಷಣೆ, ಕನ್ವರ್ಷನ್ ಟ್ರ್ಯಾಕಿಂಗ್, EMR ಏಕೀಕರಣ.',
    requestDemo: 'ಡೆಮೋ ಕೇಳಿ',
    faqEyebrow: 'ಪ್ರಶ್ನೆಗಳು',
    faqH2: 'ಮೊದಲು ಕೇಳುವುದು.',
    faq1q: 'ಇದು ಆಂಕಾಲಜಿಸ್ಟ್ ಸ್ಥಾನವನ್ನು ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆಯೇ?',
    faq4q: 'ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಮಾತ್ರವೇ?',
    faq4a: '{n} ಭಾಷೆಗಳಲ್ಲಿ ಬರೆದು ಕೇಳಿ. ಅಮೆರಿಕಕ್ಕೆ ಇಂಗ್ಲಿಷ್ ಡಿಫಾಲ್ಟ್.',
    faq5q: 'ಇದು ಯಾರಿಗಾಗಿ?',
    closeH2: 'ಗುರುವಾರ ಮತ್ತು ಮುಂದಿನ ಪೋರ್ಟಲ್ ಸಂದೇಶದ ನಡುವೆ ಯಾರೂ ಒಂಟಿಯಾಗಿರಬಾರದು.',
    servicesH2: 'ಸಂಪೂರ್ಣ ಕ್ಯಾನ್ಸರ್ ಆರೈಕೆ, ಸಂಭಾಷಣೆಯಾಚೆ',
    servicesLead: 'ByOnco ನಿಮ್ಮನ್ನು ಅಮೆರಿಕನ್ ಆಸ್ಪತ್ರೆಗಳು, USD ವೆಚ್ಚ ಕೋಷ್ಟಕಗಳು, ಅಪರೂಪದ ಕ್ಯಾನ್ಸರ್ ಮಾರ್ಗಗಳು, ಎರಡನೇ ಅಭಿಪ್ರಾಯಗಳು ಮತ್ತು ಕೇರ್ ಪ್ಯಾಕೇಜ್‌ಗಳಿಗೆ ಜೋಡಿಸುತ್ತದೆ.',
    howByonco: 'ByOnco ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ',
    howByoncoH2: 'ByOnco ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ',
    specializedCare: 'ವಿಶೇಷ ಆರೈಕೆ',
    rareUltraH2: 'ಅಪರೂಪದ ಮತ್ತು ಅತ್ಯಂತ ಅಪರೂಪದ ಕ್ಯಾನ್ಸರ್ ಪರಿಣತಿ',
    rareSpecialize: 'ನಾವು {n} ಅಪರೂಪದ ಕ್ಯಾನ್ಸರ್ ಪ್ರಕಾರಗಳಲ್ಲಿ ಪರಿಣತರು',
    rareMapped: ', {n} ಕೇಂದ್ರಗಳಲ್ಲಿ ಮ್ಯಾಪ್ ಮಾಡಲಾಗಿದೆ.',
    viewRare: 'ಎಲ್ಲ ಅಪರೂಪದ ಕ್ಯಾನ್ಸರ್‌ಗಳನ್ನು ನೋಡಿ',
    fullMarketplace: 'ಪೂರ್ಣ ಕೇರ್ ಮಾರುಕಟ್ಟೆ',
    teamEyebrow: 'ವಿಶ್ವಮಟ್ಟದ ತಂಡ ನಿರ್ಮಿಸಿದೆ',
    teamTag: 'ನೋವು ಅರ್ಥವಾಗುವವರು ನಿರ್ಮಿಸಿದ್ದಾರೆ, ಪರಿಹರಿಸುವವರು ನಡೆಸುತ್ತಾರೆ',
    hospTitle: 'ಆಸ್ಪತ್ರೆಗಳಿಗಾಗಿ',
    hospDesc: 'Hospital SaaS ತಿಂಗಳಿಗೆ $10,000: ಅರ್ಹ ಅಂತರರಾಷ್ಟ್ರೀಯ ರೆಫರಲ್‌ಗಳು, ಕನ್ವರ್ಷನ್ ಟ್ರ್ಯಾಕಿಂಗ್, ಹಾಸಿಗೆ ಮತ್ತು ಸಾಲು ವಿಶ್ಲೇಷಣೆ, EMR ಏಕೀಕರಣ.',
    hospPill: 'Hospital SaaS',
    hospH1: 'ಮೈಕ್ರೋಫೋನ್ ಹಿಂದೆ ಅಡಗದ B2B ಬಾಗಿಲು.',
    hospLede: 'ಅರ್ಹ ಅಂತರರಾಷ್ಟ್ರೀಯ ರೆಫರಲ್‌ಗಳು, ಕನ್ವರ್ಷನ್ ಟ್ರ್ಯಾಕಿಂಗ್, ಹಾಸಿಗೆ ಮತ್ತು ಸಾಲು ವಿಶ್ಲೇಷಣೆ, ಮತ್ತು EMR ಏಕೀಕರಣ. ಹೊರಗೆ ಕಳುಹಿಸುವುದು ಇದೇ. ಪಾಲುದಾರರು ವ್ಯಾಪಾರ ನೋಡಲು ಧ್ವನಿ ಡೆಮೋ ದಾಟಬೇಕಿಲ್ಲ.',
    hospMarketplace: 'ಕೇರ್ ಮಾರುಕಟ್ಟೆಯನ್ನು ನೋಡಿ',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS ತಿಂಗಳಿಗೆ $10,000.',
    hospSkuSub: 'ಲೈವ್. ವೇಟ್‌ಲಿಸ್ಟ್ ಅಲ್ಲ. ಉಳಿದ ByOncoನಂತೆಯೇ ಅದೇ ಪಾವತಿ ಮಾರ್ಗ.',
    hospRefH: 'ಅಂತರರಾಷ್ಟ್ರೀಯ ರೆಫರಲ್‌ಗಳು',
    hospRefP: 'ದಾಖಲೆ ಪ್ಯಾಕೆಟ್‌ಗಳೊಂದಿಗೆ ಅರ್ಹ ಒಳಬರುವ ಪ್ರಕರಣಗಳು, ಬ್ರೋಷರ್ ಸೈಟ್ ಮತ್ತು ಆಶೆ ಅಲ್ಲ.',
    hospBedsH: 'ಹಾಸಿಗೆಗಳು, ಸಾಲುಗಳು, ಕನ್ವರ್ಷನ್',
    hospBedsP: 'ಯಾವ ರೆಫರಲ್‌ಗಳು ಪರಿವರ್ತನೆಯಾಗುತ್ತವೆ, ಎಲ್ಲಿ ನಿಲ್ಲುತ್ತವೆ, ಸಂಯೋಜಕನಿಗೆ ಇನ್ನೂ ಏನು ಬೇಕು.',
    hospEmrH: 'EMR ಏಕೀಕರಣ',
    hospEmrP: 'ಖಾತೆ ನಿರ್ವಹಿತ ಆನ್‌ಬೋರ್ಡಿಂಗ್. ಸಮರ್ಪಿತ ಬೆಂಬಲ. ಅರಣ್ಯ ಹಸಿರು ಬಾಗಿಲು ನ್ಯಾವ್ ಮತ್ತು ಫುಟರ್‌ನಲ್ಲಿ ಮೊದಲ ದರ್ಜೆಯಾಗಿ ಉಳಿಯುತ್ತದೆ.',
    hospPartners: 'ಪಾಲುದಾರಿಕೆಯೊಂದಿಗೆ ಮಾತನಾಡಿ',
  },
  bn: {
    openTheApp: 'বিনামূল্যে শুরু করুন',
    langStatWrite: 'লেখা যায় এমন ভাষা',
    langStatSpeak: 'বলা যায় এমন ভাষা',
    product: 'পণ্য',
    company: 'কোম্পানি',
    coverage: 'কভারেজ',
    pricing: 'মূল্য',
    contact: 'যোগাযোগ',
    privacy: 'গোপনীয়তা',
    terms: 'শর্ত',
    security: 'নিরাপত্তা',
    seeHow: 'কীভাবে কাজ করে দেখুন',
    talkTeam: 'টিমের সঙ্গে কথা বলুন',
    trainedOncologists: 'অনকোলজিস্টদের প্রশিক্ষণ',
    footerBlurb: 'রোগী ও পরিবারের জন্য অনকোলজি সঙ্গী, যে ভাষায় আপনি ভাবেন।',
    footerDisclaimer: 'Vani ক্যানসার ও যত্নের সাধারণ তথ্য দেয়। নির্ণয় করে না, ওষুধ লেখে না, আপনার অনকোলজিস্টের জায়গা নেয় না।',
    footerEmergency: 'আমেরিকায় জরুরি 911; সংকটে 988-এ কল বা টেক্সট করুন।',
    speakInLangs: '{n} ভাষায় বলুন।',
    heroLede: 'ক্যানসার রোগী ও তাদের বহন করা পরিবারের জন্য সঙ্গী। চিকিৎসা, খাবার, পার্শ্বপ্রতিক্রিয়া, বীমা, বা সপ্তাহ কীভাবে কাটে, যে ভাষায় আপনি সত্যি ভাবেন সেখানে জিজ্ঞাসা করুন।',
    cancerTypesCovered: 'কভার করা ক্যানসার ধরন',
    hospitalsMapped: 'ম্যাপ করা হাসপাতাল',
    secondOpinions: 'বিশেষজ্ঞ দ্বিতীয় মত',
    problemEyebrow: 'সমস্যা',
    howEyebrow: 'কীভাবে কাজ করে',
    howSub: 'কোনো ফর্ম নেই, মেনু নেই। লেখা ইতিমধ্যে {n} ভাষায় কাজ করে।',
    howAskH: 'নিজের কথায় জিজ্ঞাসা করুন',
    howAskP: 'যেমন বলেন তেমন লিখুন, {n} ভাষায়। chemotherapy ও platelets ইংরেজিতে রাখুন। আমেরিকান যত্নের জন্য ইংরেজি ডিফল্ট।',
    howAnswerH: 'ছোট, মানুষের মতো উত্তর',
    howRememberH: 'সে মনে রাখে',
    langEyebrow: 'ভাষা',
    scopeEyebrow: 'কভারেজ',
    scopeH2: 'ক্যানসারের ধরন, এবং তার চারপাশের পুরো জীবন।',
    scopeH2n: '{n} ক্যানসার ধরন, এবং তার চারপাশের পুরো জীবন।',
    cardTreatH: 'চিকিৎসা ও ট্রান্সপ্ল্যান্ট',
    cardWarnH: 'যা কেউ আগে বলে না',
    cardMoneyH: 'টাকা ও লজিস্টিকস',
    cardRareH: 'দুর্লভ ক্যানসার, কাঁধ না নাড়িয়ে',
    cardCareH: 'পাশে থাকা মানুষের জন্য',
    cardRefuseH: 'যা সে প্রত্যাখ্যান করে',
    safetyEyebrow: 'নিরাপত্তা',
    safetyH2: 'এমন মানুষ তৈরি করেছে যারা মনে করে রাত ৩টায় ভয় পাওয়া কেউ ব্যবহার করবে।',
    safetyRedK: 'রেড ফ্ল্যাগ',
    safetyInventK: 'কোনো উদ্ভাবন নয়',
    safetyBoundK: 'সীমা',
    safetyDistressK: 'সংকট',
    safetyPrivK: 'গোপনীয়তা',
    priceEyebrow: 'মূল্য',
    priceSub: 'প্ল্যান মাসে $14.99 থেকে শুরু, $39.99 থেকে কমানো। যেকোনো সময় বাতিলযোগ্য।',
    planFree: 'ফ্রি',
    planFreeWho: 'আগে চেষ্টা করুন',
    planFree1: '২টি প্রশ্ন, কার্ড নেই',
    planFree2: 'সব {n} ভাষা',
    planProWho: 'রোগী ও পরিবার',
    planProTag: 'বেশিরভাগ পরিবার এটি বেছে নেয়',
    planPro1: '{n} ভাষায় সীমাহীন প্রশ্ন',
    startPro: 'PRO শুরু করুন',
    planLife: 'আজীবন',
    getLifetime: 'আজীবন নিন',
    saasLead: 'ক্যানসার কেন্দ্র:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'আন্তর্জাতিক রেফারেল, বেড ও সারি বিশ্লেষণ, কনভার্সন ট্র্যাকিং, EMR ইন্টিগ্রেশন।',
    requestDemo: 'ডেমো চান',
    faqEyebrow: 'প্রশ্ন',
    faqH2: 'মানুষ প্রথমে যা জিজ্ঞাসা করে।',
    faq1q: 'এটি কি অনকোলজিস্টের জায়গা নেয়?',
    faq4q: 'শুধু ইংরেজিতে?',
    faq4a: '{n} ভাষায় লিখে জিজ্ঞাসা করুন। আমেরিকার জন্য ইংরেজি ডিফল্ট।',
    faq5q: 'এটি কার জন্য?',
    closeH2: 'বৃহস্পতিবার ও পরের পোর্টাল বার্তার মাঝে কাউকে একা পড়তে দেওয়া উচিত নয়।',
    servicesH2: 'সম্পূর্ণ ক্যানসার যত্ন, কথোপকথনের বাইরে',
    servicesLead: 'ByOnco আপনাকে আমেরিকান হাসপাতাল, USD খরচ সারণি, দুর্লভ ক্যানসার পথ, দ্বিতীয় মত ও কেয়ার প্যাকেজের সঙ্গে যুক্ত করে।',
    howByonco: 'ByOnco কীভাবে কাজ করে',
    howByoncoH2: 'ByOnco কীভাবে কাজ করে',
    specializedCare: 'বিশেষ যত্ন',
    rareUltraH2: 'দুর্লভ ও অতি-দুর্লভ ক্যানসার দক্ষতা',
    rareSpecialize: 'আমরা {n} দুর্লভ ক্যানসার ধরনে বিশেষজ্ঞ',
    rareMapped: ', {n} কেন্দ্রে ম্যাপ করা।',
    viewRare: 'সব দুর্লভ ক্যানসার দেখুন',
    fullMarketplace: 'পূর্ণ কেয়ার মার্কেটপ্লেস',
    teamEyebrow: 'বিশ্বমানের দল তৈরি করেছে',
    teamTag: 'ব্যথা বোঝে এমন মানুষ তৈরি করেছে, সমাধান করতে পারে এমন মানুষ চালায়',
    hospTitle: 'হাসপাতালের জন্য',
    hospDesc: 'Hospital SaaS মাসে $10,000: যোগ্য আন্তর্জাতিক রেফারেল, কনভার্সন ট্র্যাকিং, বেড ও সারি বিশ্লেষণ, EMR ইন্টিগ্রেশন।',
    hospPill: 'Hospital SaaS',
    hospH1: 'মাইক্রোফোনের পেছনে লুকোয় না এমন B2B দরজা।',
    hospLede: 'যোগ্য আন্তর্জাতিক রেফারেল, কনভার্সন ট্র্যাকিং, বেড ও সারি বিশ্লেষণ, এবং EMR ইন্টিগ্রেশন। বাইরে পাঠায় এটাই। পার্টনারদের ব্যবসা দেখতে ভয়েস ডেমো পেরোতে হয় না।',
    hospMarketplace: 'কেয়ার মার্কেটপ্লেস দেখুন',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS মাসে $10,000।',
    hospSkuSub: 'লাইভ। ওয়েটলিস্ট নয়। বাকি ByOnco-র মতোই পেমেন্ট পথ।',
    hospRefH: 'আন্তর্জাতিক রেফারেল',
    hospRefP: 'ডকুমেন্ট প্যাকেটসহ যোগ্য ইনবাউন্ড কেস, ব্রোশার সাইট ও আশা নয়।',
    hospBedsH: 'বেড, সারি, কনভার্সন',
    hospBedsP: 'কোন রেফারেল কনভার্ট হয়, কোথায় আটকে যায়, কোঅর্ডিনেটরের এখনও কী দরকার।',
    hospEmrH: 'EMR ইন্টিগ্রেশন',
    hospEmrP: 'অ্যাকাউন্ট-ম্যানেজড অনবোর্ডিং। নিবেদিত সাপোর্ট। বন-সবুজ দরজা ন্যাভ ও ফুটারে প্রথম শ্রেণি থাকে।',
    hospPartners: 'পার্টনারশিপের সঙ্গে কথা বলুন',
  },
  gu: {
    openTheApp: 'મફત શરૂ કરો',
    langStatWrite: 'લખી શકાય તેવી ભાષાઓ',
    langStatSpeak: 'બોલી શકાય તેવી ભાષાઓ',
    product: 'ઉત્પાદન',
    company: 'કંપની',
    coverage: 'કવરેજ',
    pricing: 'કિંમત',
    contact: 'સંપર્ક',
    privacy: 'ગોપનીયતા',
    terms: 'નિયમો',
    security: 'સુરક્ષા',
    seeHow: 'કેવી રીતે કામ કરે છે તે જુઓ',
    talkTeam: 'ટીમ સાથે વાત કરો',
    trainedOncologists: 'ઑન્કોલોજિસ્ટ દ્વારા તાલીમ',
    footerBlurb: 'દર્દીઓ અને પરિવારો માટે ઑન્કોલોજી સાથી, જે ભાષામાં તમે વિચારો છો તેમાં.',
    footerDisclaimer: 'Vani કેન્સર અને સંભાળની સામાન્ય માહિતી આપે છે. નિદાન કરતી નથી, દવા લખતી નથી, અને તમારા ઑન્કોલોજિસ્ટની જગ્યા લેતી નથી.',
    footerEmergency: 'અમેરિકામાં ઇમર્જન્સી પર 911; સંકટ માટે 988 પર કૉલ અથવા ટેક્સ્ટ કરો.',
    speakInLangs: '{n} ભાષામાં બોલો.',
    heroLede: 'કેન્સરના દર્દીઓ અને તેમને સંભાળનારા પરિવારો માટે સાથી. સારવાર, ખોરાક, સાઇડ ઇફેક્ટ, વીમો, અથવા અઠવાડિયું કેવી રીતે કાઢવું, જે ભાષામાં તમે ખરેખર વિચારો છો તેમાં પૂછો.',
    cancerTypesCovered: 'કવર થયેલા કેન્સર પ્રકાર',
    hospitalsMapped: 'મેપ થયેલી હોસ્પિટલ',
    secondOpinions: 'નિષ્ણાત બીજો અભિપ્રાય',
    problemEyebrow: 'સમસ્યા',
    howEyebrow: 'કેવી રીતે કામ કરે છે',
    howSub: 'ફોર્મ નથી, મેનૂ નથી. લખવું પહેલેથી {n} ભાષામાં ચાલે છે.',
    howAskH: 'તમારા શબ્દોમાં પૂછો',
    howAskP: 'જેમ બોલો તેમ લખો, {n} ભાષામાં. chemotherapy અને platelets અંગ્રેજીમાં રાખો. અમેરિકન સંભાળ માટે અંગ્રેજી ડિફોલ્ટ છે.',
    howAnswerH: 'નાનો, માનવ જેવો જવાબ',
    howRememberH: 'તે યાદ રાખે છે',
    langEyebrow: 'ભાષાઓ',
    scopeEyebrow: 'કવરેજ',
    scopeH2: 'કેન્સરના પ્રકાર, અને તેની આસપાસનું આખું જીવન.',
    scopeH2n: '{n} કેન્સર પ્રકાર, અને તેની આસપાસનું આખું જીવન.',
    cardTreatH: 'સારવાર અને ટ્રાન્સપ્લાન્ટ',
    cardWarnH: 'જેની કોઈ ચેતવણી આપતું નથી',
    cardMoneyH: 'પૈસા અને લોજિસ્ટિક્સ',
    cardRareH: 'દુર્લભ કેન્સર, ખભા ઉઠાવ્યા વગર',
    cardCareH: 'બાજુમાં રહેનાર માટે',
    cardRefuseH: 'તે શું નકારે છે',
    safetyEyebrow: 'સુરક્ષા',
    safetyH2: 'એવા લોકોએ બનાવ્યું જે માને છે કે રાત્રે 3 વાગ્યે ડરેલો કોઈ વાપરશે.',
    safetyRedK: 'રેડ ફ્લેગ',
    safetyInventK: 'કોઈ કલ્પના નહીં',
    safetyBoundK: 'સીમાઓ',
    safetyDistressK: 'સંકટ',
    safetyPrivK: 'ગોપનીયતા',
    priceEyebrow: 'કિંમત',
    priceSub: 'પ્લાન મહિને $14.99થી શરૂ, $39.99થી ઘટાડીને. ગમે ત્યારે રદ કરી શકો છો.',
    planFree: 'મફત',
    planFreeWho: 'પહેલા અજમાવો',
    planFree1: '2 પ્રશ્નો, કાર્ડ નહીં',
    planFree2: 'બધી {n} ભાષાઓ',
    planProWho: 'દર્દીઓ અને પરિવારો',
    planProTag: 'મોટાભાગના પરિવારો આ પસંદ કરે છે',
    planPro1: '{n} ભાષામાં અમર્યાદિત પ્રશ્નો',
    startPro: 'PRO શરૂ કરો',
    planLife: 'આજીવન',
    getLifetime: 'આજીવન લો',
    saasLead: 'કેન્સર કેન્દ્રો:',
    saasBold: 'Hospital SaaS at $10,000/month',
    saasRest: 'આંતરરાષ્ટ્રીય રેફરલ, બેડ અને કતાર એનાલિટિક્સ, કન્વર્ઝન ટ્રેકિંગ, EMR ઇન્ટિગ્રેશન.',
    requestDemo: 'ડેમો માંગો',
    faqEyebrow: 'પ્રશ્નો',
    faqH2: 'લોકો પહેલા શું પૂછે છે.',
    faq1q: 'શું આ ઑન્કોલોજિસ્ટની જગ્યા લે છે?',
    faq4q: 'ફક્ત અંગ્રેજીમાં?',
    faq4a: '{n} ભાષામાં લખીને પૂછો. અમેરિકા માટે અંગ્રેજી ડિફોલ્ટ છે.',
    faq5q: 'આ કોના માટે છે?',
    closeH2: 'ગુરુવાર અને આગલા પોર્ટલ મેસેજ વચ્ચે કોઈને એકલા ન પડવું જોઈએ.',
    servicesH2: 'સંપૂર્ણ કેન્સર સંભાળ, વાતચીતની આગળ',
    servicesLead: 'ByOnco તમને અમેરિકન હોસ્પિટલ, USD ખર્ચ કોષ્ટક, દુર્લભ કેન્સર માર્ગ, બીજા અભિપ્રાય અને કેર પેકેજ સાથે જોડે છે.',
    howByonco: 'ByOnco કેવી રીતે કામ કરે છે',
    howByoncoH2: 'ByOnco કેવી રીતે કામ કરે છે',
    specializedCare: 'વિશેષ સંભાળ',
    rareUltraH2: 'દુર્લભ અને અતિ-દુર્લભ કેન્સર નિપુણતા',
    rareSpecialize: 'અમે {n} દુર્લભ કેન્સર પ્રકારમાં નિષ્ણાત છીએ',
    rareMapped: ', {n} કેન્દ્રોમાં મેપ થયેલા.',
    viewRare: 'બધા દુર્લભ કેન્સર જુઓ',
    fullMarketplace: 'પૂર્ણ કેર માર્કેટપ્લેસ',
    teamEyebrow: 'વિશ્વકક્ષાની ટીમે બનાવ્યું',
    teamTag: 'દુખ સમજનારાએ બનાવ્યું, ઉકેલી શકનારાએ ચલાવ્યું',
    hospTitle: 'હોસ્પિટલો માટે',
    hospDesc: 'Hospital SaaS મહિને $10,000: લાયક આંતરરાષ્ટ્રીય રેફરલ, કન્વર્ઝન ટ્રેકિંગ, બેડ અને કતાર એનાલિટિક્સ, EMR ઇન્ટિગ્રેશન.',
    hospPill: 'Hospital SaaS',
    hospH1: 'માઇક્રોફોન પાછળ ન છુપાતું B2B દરવાજું.',
    hospLede: 'લાયક આંતરરાષ્ટ્રીય રેફરલ, કન્વર્ઝન ટ્રેકિંગ, બેડ અને કતાર એનાલિટિક્સ, અને EMR ઇન્ટિગ્રેશન. બહાર મોકલાય છે તે આ. પાર્ટનરને વ્યવસાય જોવા વૉઇસ ડેમો પાર કરવું પડતું નથી.',
    hospMarketplace: 'કેર માર્કેટપ્લેસ જુઓ',
    hospSkuEyebrow: 'SKU',
    hospSkuH2: 'Hospital SaaS મહિને $10,000.',
    hospSkuSub: 'લાઇવ. વેટલિસ્ટ નહીં. બાકી ByOnco જેવો જ પેમેન્ટ માર્ગ.',
    hospRefH: 'આંતરરાષ્ટ્રીય રેફરલ',
    hospRefP: 'દસ્તાવેજ પેકેટ સાથે લાયક ઇનબાઉન્ડ કેસ, બ્રોશર સાઇટ અને આશા નહીં.',
    hospBedsH: 'બેડ, કતાર, કન્વર્ઝન',
    hospBedsP: 'કયા રેફરલ કન્વર્ટ થાય છે, ક્યાં અટકે છે, અને કોઓર્ડિનેટરને હજુ શું જોઈએ.',
    hospEmrH: 'EMR ઇન્ટિગ્રેશન',
    hospEmrP: 'એકાઉન્ટ-મેનેજ્ડ ઓનબોર્ડિંગ. સમર્પિત સપોર્ટ. વન-લીલું દરવાજું નેવ અને ફૂટરમાં પ્રથમ શ્રેણી રહે છે.',
    hospPartners: 'પાર્ટનરશિપ સાથે વાત કરો',
  },
};
